(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-post-checkout"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const copyText = async (text) => {
      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(text);
          return;
        } catch (error) {
          // Use the selection fallback when clipboard permission is denied.
        }
      }

      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      const copied = document.execCommand('copy');
      textarea.remove();

      if (!copied) throw new Error('Copy failed');
    };

    document.addEventListener('click', async (event) => {
      if (!(event.target instanceof Element)) return;

      const button = event.target.closest('[data-copy-discount]');
      if (!button) return;

      const code = button.dataset.copyDiscount;
      if (!code) return;

      const label = button.querySelector('[data-copy-label]');
      const section = button.closest('[id^="CartPostCheckout-"]');
      const status = section?.querySelector('[data-copy-status]');
      const originalLabel = label?.dataset.originalLabel || label?.textContent || 'Copy';

      if (label && !label.dataset.originalLabel) label.dataset.originalLabel = originalLabel;
      if (button.copyResetTimer) window.clearTimeout(button.copyResetTimer);

      try {
        await copyText(code);
        button.classList.add('is-copied');
        if (label) label.textContent = 'Copied';
        if (status) status.textContent = `Discount code ${code} copied.`;

        button.copyResetTimer = window.setTimeout(() => {
          button.classList.remove('is-copied');
          if (label) label.textContent = originalLabel;
          button.copyResetTimer = null;
        }, 2200);
      } catch (error) {
        button.classList.remove('is-copied');
        if (label) label.textContent = originalLabel;
        if (status) status.textContent = `Could not copy ${code}. Please select the code manually.`;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-photo-reviews"] && !Shopify.designMode) return;
  try {
    
  const compactReviewsMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if ('customElements' in window && !customElements.get('compact-photo-reviews')) {
    class CompactPhotoReviews extends HTMLElement {
      constructor() {
        super();

        this.initialized = false;
        this.cards = [];
        this.dots = [];
        this.cardOffsets = [];
        this.currentIndex = -1;
        this.autoplayTimer = null;
        this.scrollFrame = null;
        this.refreshFrame = null;
        this.resizeObserver = null;
        this.visibilityObserver = null;
        this.blurObserver = null;
        this.isVisible = !('IntersectionObserver' in window);
        this.isHovered = false;
        this.hasFocus = false;
        this.pointerActive = false;
        this.modalOpen = false;
        this.lastFocusedElement = null;

        this.handleClick = this.onClick.bind(this);
        this.handleScroll = this.onScroll.bind(this);
        this.handleTrackKeydown = this.onTrackKeydown.bind(this);
        this.handleModalKeydown = this.onModalKeydown.bind(this);
        this.handleVisibilityChange = this.onVisibilityChange.bind(this);
        this.handleMotionChange = this.onMotionChange.bind(this);
        this.handleMouseEnter = this.onMouseEnter.bind(this);
        this.handleMouseLeave = this.onMouseLeave.bind(this);
        this.handleFocusIn = this.onFocusIn.bind(this);
        this.handleFocusOut = this.onFocusOut.bind(this);
        this.handlePointerDown = this.onPointerDown.bind(this);
        this.handlePointerEnd = this.onPointerEnd.bind(this);
        this.handleResize = this.queueRefresh.bind(this);
        this.handleIntersection = this.onIntersection.bind(this);
        this.handleBlurIntersection = this.onBlurIntersection.bind(this);
      }

      connectedCallback() {
        if (this.initialized) {
          return;
        }

        this.track = this.querySelector('[data-cr-track]');
        this.cards = Array.from(this.querySelectorAll('[data-cr-card]'));

        if (!this.track || !this.cards.length) {
          return;
        }

        this.initialized = true;
        this.dots = Array.from(this.querySelectorAll('[data-cr-dot]'));
        this.dotsContainer = this.querySelector('.cr-dots');
        this.blurElements = Array.from(this.querySelectorAll('[data-cr-blur]'));
        this.currentCounter = this.querySelector('[data-cr-current]');
        this.controls = this.querySelector('[data-cr-controls]');
        this.modal = this.querySelector('[data-cr-modal]');
        this.modalContent = this.querySelector('[data-cr-modal-content]');
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.autoplaySpeed = Math.max(
          2000,
          Number.parseInt(this.dataset.autoplaySpeed, 10) || 2000
        );

        this.addEventListener('click', this.handleClick);
        this.addEventListener('mouseenter', this.handleMouseEnter);
        this.addEventListener('mouseleave', this.handleMouseLeave);
        this.addEventListener('focusin', this.handleFocusIn);
        this.addEventListener('focusout', this.handleFocusOut);
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.track.addEventListener('keydown', this.handleTrackKeydown);
        this.track.addEventListener('pointerdown', this.handlePointerDown, { passive: true });
        this.track.addEventListener('pointerup', this.handlePointerEnd, { passive: true });
        this.track.addEventListener('pointercancel', this.handlePointerEnd, { passive: true });
        document.addEventListener('visibilitychange', this.handleVisibilityChange);

        if (typeof compactReviewsMotion.addEventListener === 'function') {
          compactReviewsMotion.addEventListener('change', this.handleMotionChange);
        } else {
          compactReviewsMotion.addListener(this.handleMotionChange);
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.handleResize);
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', this.handleResize);
        }

        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(this.handleIntersection, {
            rootMargin: '150px 0px',
            threshold: 0.01
          });
          this.visibilityObserver.observe(this);

          if (this.blurElements.length) {
            this.blurObserver = new IntersectionObserver(this.handleBlurIntersection, {
              root: this.track,
              rootMargin: '0px 240px',
              threshold: 0.01
            });
            this.blurElements.forEach((element) => this.blurObserver.observe(element));
          }
        } else {
          this.blurElements.forEach((element) => this.loadBlurBackground(element));
        }

        this.queueRefresh();
      }

      disconnectedCallback() {
        if (!this.initialized) {
          return;
        }

        this.stopAutoplay();

        if (this.scrollFrame) {
          window.cancelAnimationFrame(this.scrollFrame);
        }

        if (this.refreshFrame) {
          window.cancelAnimationFrame(this.refreshFrame);
        }

        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.blurObserver?.disconnect();

        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('mouseenter', this.handleMouseEnter);
        this.removeEventListener('mouseleave', this.handleMouseLeave);
        this.removeEventListener('focusin', this.handleFocusIn);
        this.removeEventListener('focusout', this.handleFocusOut);
        this.track.removeEventListener('scroll', this.handleScroll);
        this.track.removeEventListener('keydown', this.handleTrackKeydown);
        this.track.removeEventListener('pointerdown', this.handlePointerDown);
        this.track.removeEventListener('pointerup', this.handlePointerEnd);
        this.track.removeEventListener('pointercancel', this.handlePointerEnd);
        document.removeEventListener('keydown', this.handleModalKeydown);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        window.removeEventListener('resize', this.handleResize);

        if (typeof compactReviewsMotion.removeEventListener === 'function') {
          compactReviewsMotion.removeEventListener('change', this.handleMotionChange);
        } else {
          compactReviewsMotion.removeListener(this.handleMotionChange);
        }

        this.resetModal();
        this.cards = [];
        this.dots = [];
        this.cardOffsets = [];
        this.blurElements = [];
        this.currentIndex = -1;
        this.hasOverflow = false;
        this.isVisible = !('IntersectionObserver' in window);
        this.isHovered = false;
        this.hasFocus = false;
        this.pointerActive = false;
        this.lastFocusedElement = null;
        this.track = null;
        this.initialized = false;
      }

      canAutoplay() {
        return (
          this.autoplayEnabled &&
          !compactReviewsMotion.matches &&
          this.cards.length > 1 &&
          this.hasOverflow &&
          this.isVisible &&
          !this.isHovered &&
          !this.hasFocus &&
          !this.pointerActive &&
          !this.modalOpen &&
          !document.hidden
        );
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          window.clearTimeout(this.autoplayTimer);
          this.autoplayTimer = null;
        }
      }

      startAutoplay(delay = this.autoplaySpeed) {
        this.stopAutoplay();

        if (!this.canAutoplay()) {
          return;
        }

        this.autoplayTimer = window.setTimeout(() => {
          this.autoplayTimer = null;

          if (!this.canAutoplay()) {
            return;
          }

          this.showNext();
          this.startAutoplay();
        }, delay);
      }

      queueRefresh() {
        if (this.refreshFrame) {
          window.cancelAnimationFrame(this.refreshFrame);
        }

        this.refreshFrame = window.requestAnimationFrame(() => {
          this.refreshFrame = null;
          this.refreshMetrics();
        });
      }

      refreshMetrics() {
        if (!this.track) {
          return;
        }

        const trackRect = this.track.getBoundingClientRect();
        const scrollLeft = this.track.scrollLeft;

        this.cardOffsets = this.cards.map((card) => (
          scrollLeft + card.getBoundingClientRect().left - trackRect.left
        ));

        this.hasOverflow = this.track.scrollWidth > this.track.clientWidth + 3;
        this.classList.toggle('cr-no-overflow', !this.hasOverflow);

        if (this.controls) {
          this.controls.setAttribute('aria-hidden', String(!this.hasOverflow));
        }

        this.setCurrentIndex(this.getNearestCardIndex(), true);
        this.startAutoplay(500);
      }

      getNearestCardIndex() {
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;
        const scrollLeft = this.track?.scrollLeft || 0;

        this.cardOffsets.forEach((offset, index) => {
          const distance = Math.abs(offset - scrollLeft);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        return nearestIndex;
      }

      setCurrentIndex(index, force = false) {
        const safeIndex = Math.max(0, Math.min(index, this.cards.length - 1));

        if (!force && safeIndex === this.currentIndex) {
          return;
        }

        this.currentIndex = safeIndex;

        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === safeIndex;
          dot.classList.toggle('is-active', active);

          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });

        if (this.currentCounter) {
          this.currentCounter.textContent = String(safeIndex + 1);
        }

        const activeDot = this.dots[safeIndex];

        if (activeDot && this.dotsContainer) {
          const targetLeft = activeDot.offsetLeft -
            (this.dotsContainer.clientWidth - activeDot.offsetWidth) / 2;

          this.dotsContainer.scrollTo({
            left: Math.max(0, targetLeft),
            behavior: compactReviewsMotion.matches ? 'auto' : 'smooth'
          });
        }
      }

      scrollToCard(index) {
        if (!this.track || !this.cardOffsets.length) {
          return;
        }

        const safeIndex = Math.max(0, Math.min(index, this.cards.length - 1));
        const maximumScroll = this.track.scrollWidth - this.track.clientWidth;
        const targetLeft = Math.max(
          0,
          Math.min(this.cardOffsets[safeIndex], maximumScroll)
        );

        this.track.scrollTo({
          left: targetLeft,
          behavior: compactReviewsMotion.matches ? 'auto' : 'smooth'
        });

        this.setCurrentIndex(safeIndex);
      }

      showNext() {
        if (!this.hasOverflow) {
          return;
        }

        this.scrollToCard(
          this.currentIndex >= this.cards.length - 1 ? 0 : this.currentIndex + 1
        );
      }

      showPrevious() {
        if (!this.hasOverflow) {
          return;
        }

        this.scrollToCard(
          this.currentIndex <= 0 ? this.cards.length - 1 : this.currentIndex - 1
        );
      }

      onScroll() {
        if (this.scrollFrame) {
          window.cancelAnimationFrame(this.scrollFrame);
        }

        this.scrollFrame = window.requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.setCurrentIndex(this.getNearestCardIndex());
        });
      }

      onClick(event) {
        if (!(event.target instanceof Element)) {
          return;
        }

        const closeButton = event.target.closest('[data-cr-close]');

        if (closeButton && this.contains(closeButton)) {
          this.closeModal();
          return;
        }

        const previousButton = event.target.closest('[data-cr-prev]');

        if (previousButton && this.contains(previousButton)) {
          this.showPrevious();
          this.startAutoplay(3000);
          return;
        }

        const nextButton = event.target.closest('[data-cr-next]');

        if (nextButton && this.contains(nextButton)) {
          this.showNext();
          this.startAutoplay(3000);
          return;
        }

        const dot = event.target.closest('[data-cr-dot]');

        if (dot && this.contains(dot)) {
          this.scrollToCard(Number.parseInt(dot.dataset.index, 10) || 0);
          this.startAutoplay(3000);
          return;
        }

        const openButton = event.target.closest('[data-cr-open]');

        if (openButton && this.contains(openButton)) {
          this.openModal(openButton.closest('[data-cr-card]'), openButton);
        }
      }

      openModal(card, trigger) {
        if (!this.modal || !this.modalContent || !card) {
          return;
        }

        const template = card.querySelector('[data-cr-template]');

        if (!template) {
          return;
        }

        this.stopAutoplay();
        this.lastFocusedElement = trigger || document.activeElement;
        this.modalContent.replaceChildren(template.content.cloneNode(true));
        this.modal.inert = false;
        this.modal.classList.add('is-open');
        this.modal.setAttribute('aria-hidden', 'false');
        this.modalOpen = true;
        document.body.classList.add('cr-modal-locked');
        document.addEventListener('keydown', this.handleModalKeydown);

        window.requestAnimationFrame(() => {
          this.modal.querySelector('.cr-modal-close')?.focus();
        });
      }

      closeModal(restoreFocus = true, resumeAutoplay = true) {
        if (!this.modalOpen) {
          return;
        }

        this.modalContent?.querySelectorAll('video').forEach((video) => video.pause());
        this.modal?.classList.remove('is-open');
        this.modal?.setAttribute('aria-hidden', 'true');

        if (this.modal) {
          this.modal.inert = true;
        }

        this.modalContent?.replaceChildren();
        this.modalOpen = false;
        document.removeEventListener('keydown', this.handleModalKeydown);

        if (!document.querySelector('.cr-modal.is-open')) {
          document.body.classList.remove('cr-modal-locked');
        }

        const focusTarget = this.lastFocusedElement;
        this.lastFocusedElement = null;

        if (restoreFocus && focusTarget instanceof HTMLElement) {
          focusTarget.focus();
        }

        if (resumeAutoplay) {
          this.startAutoplay(2000);
        }
      }

      resetModal() {
        if (this.modalOpen) {
          this.closeModal(false, false);
        }

        document.removeEventListener('keydown', this.handleModalKeydown);
        this.modalContent?.replaceChildren();

        if (!document.querySelector('.cr-modal.is-open')) {
          document.body.classList.remove('cr-modal-locked');
        }
      }

      onModalKeydown(event) {
        if (!this.modalOpen || !this.modal) {
          return;
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeModal();
          return;
        }

        if (event.key !== 'Tab') {
          return;
        }

        const focusableElements = Array.from(
          this.modal.querySelectorAll(
            'button:not([disabled]), a[href], video[controls], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )
        );

        if (!focusableElements.length) {
          return;
        }

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }

      onTrackKeydown(event) {
        if (event.target !== this.track) {
          return;
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showPrevious();
          this.startAutoplay(3000);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.showNext();
          this.startAutoplay(3000);
        }
      }

      onVisibilityChange() {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this.startAutoplay(1000);
        }
      }

      onMotionChange() {
        if (compactReviewsMotion.matches) {
          this.stopAutoplay();
        } else {
          this.startAutoplay(1000);
        }
      }

      onIntersection(entries) {
        const entry = entries.find((item) => item.target === this);

        if (!entry) {
          return;
        }

        this.isVisible = entry.isIntersecting;

        if (this.isVisible) {
          this.startAutoplay(500);
        } else {
          this.stopAutoplay();
        }
      }

      onBlurIntersection(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadBlurBackground(entry.target);
          }
        });
      }

      loadBlurBackground(element) {
        const imageUrl = element.dataset.crBlur;

        if (!imageUrl) {
          return;
        }

        element.style.setProperty('--cr-media-bg', `url("${imageUrl}")`);
        element.removeAttribute('data-cr-blur');
        this.blurObserver?.unobserve(element);
      }

      onMouseEnter() {
        this.isHovered = true;
        this.stopAutoplay();
      }

      onMouseLeave() {
        this.isHovered = false;
        this.startAutoplay(1000);
      }

      onFocusIn() {
        this.hasFocus = true;
        this.stopAutoplay();
      }

      onFocusOut(event) {
        if (!this.contains(event.relatedTarget)) {
          this.hasFocus = false;
          this.startAutoplay(1000);
        }
      }

      onPointerDown() {
        this.pointerActive = true;
        this.stopAutoplay();
      }

      onPointerEnd() {
        this.pointerActive = false;
        this.startAutoplay(3500);
      }
    }

    customElements.define('compact-photo-reviews', CompactPhotoReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (!customElements.get('yfc-variant-card')) {
    customElements.define('yfc-variant-card', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        // Choices and state templates stay in place when price/image content changes.
        this.choiceLinks = null;
        this.variantStates = null;
        const enhance = () => {
          if (!this.isConnected || signal.aborted) return;
          this.getChoices().forEach(link => {
            link.setAttribute('role', 'button');
            link.setAttribute('aria-pressed', String(link.classList.contains('is-selected')));
            link.removeAttribute('aria-current');
          });
          const select = this.querySelector('[data-yfc-select]');
          if (select) {
            this.querySelector('[data-yfc-choice-links]').hidden = true;
            this.querySelector('[data-yfc-select-wrap]').hidden = false;
            select.value = this.getChoices().find(link => link.classList.contains('is-selected'))?.dataset.yfcChoice || select.value;
          }
          this.refreshPhotos();
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true, signal });
        else enhance();
        this.addEventListener('change', event => {
          const select = event.target;
          if (!select.matches('[data-yfc-select]')) return;
          if (this.querySelector('.loading, button[aria-disabled="true"]')) {
            select.value = this.getChoices().find(link => link.classList.contains('is-selected'))?.dataset.yfcChoice || select.value;
            return;
          }
          const choice = this.getChoices().find(link => link.dataset.yfcChoice === select.value);
          choice?.click();
        }, { signal });
        this.addEventListener('keydown', event => {
          if (event.defaultPrevented || event.isComposing || event.altKey || event.ctrlKey || event.metaKey) return;
          if (event.key === ' ' && event.target.matches('a[data-yfc-choice]')) {
            event.preventDefault();
            event.target.click();
          }
        }, { signal });
        this.addEventListener('pointerover', event => {
          const media = event.target.closest('.yfc-media');
          if (!media || media.contains(event.relatedTarget) || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          this.photoHovered = true;
          this.updatePhoto();
        }, { signal });
        this.addEventListener('pointerout', event => {
          const media = event.target.closest('.yfc-media');
          if (!media || media.contains(event.relatedTarget)) return;
          this.photoHovered = false;
          this.updatePhoto();
        }, { signal });
        this.addEventListener('click', event => {
          if (event.target.closest('[data-yfc-photo-toggle]')) {
            this.photoMode = this.photoRequested ? 'primary' : 'secondary';
            this.updatePhoto();
            return;
          }
          const choice = event.target.closest('a[data-yfc-choice]');
          if (!choice || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const state = this.getVariantState(choice.dataset.yfcChoice);
          if (!state) return;
          event.preventDefault();
          if (this.querySelector('.loading, button[aria-disabled="true"]')) return;
          if (choice.classList.contains('is-selected')) return;
          for (const part of ['price', 'facts', 'unit', 'image']) {
            const target = this.querySelector(`[data-yfc-${part}]`);
            const content = state.content.querySelector(`[data-yfc-${part}-state]`);
            if (target && content) {
              target.replaceChildren(...Array.from(content.childNodes, node => node.cloneNode(true)));
              if (part === 'facts' || part === 'unit') target.setAttribute('aria-hidden', String(!target.textContent.trim()));
            }
          }
          this.querySelectorAll('a[data-yfc-product-link]').forEach(link => { link.href = choice.href; });
          this.querySelectorAll('[data-product-url]').forEach(button => { button.dataset.productUrl = choice.getAttribute('href'); });
          const input = this.querySelector('form input[name="id"]');
          if (input) {
            input.value = choice.dataset.yfcChoice;
            input.disabled = false;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          this.getChoices().forEach(link => {
            link.setAttribute('aria-pressed', String(link === choice));
            link.classList.toggle('is-selected', link === choice);
          });
          const select = this.querySelector('[data-yfc-select]');
          if (select) select.value = choice.dataset.yfcChoice;
          this.refreshPhotos();
          const productForm = this.querySelector('product-form');
          productForm?.handleErrorMessage?.();
          // Only available variants have choice links. Keep native cart submission.
          const submit = productForm?.querySelector('button[type="submit"]');
          if (submit) {
            submit.disabled = false;
            const label = submit.querySelector('[data-yfc-submit-label]');
            if (label) label.textContent = productForm.dataset.yfcAddLabel;
          }
          const status = this.querySelector('[data-yfc-status]');
          if (status) status.textContent = `${choice.dataset.yfcLabel || choice.textContent.trim()}: ${this.querySelector('[data-yfc-amount]')?.textContent.trim() || ''}`;
        }, { signal });
      }
      getChoices() {
        return this.choiceLinks ||= Array.from(this.querySelectorAll('a[data-yfc-choice]'));
      }
      getVariantState(id) {
        if (!this.variantStates) {
          this.variantStates = new Map(Array.from(this.querySelectorAll('template[data-yfc-variant]'),
            template => [template.dataset.yfcVariant, template]));
        }
        return this.variantStates.get(id);
      }
      refreshPhotos() {
        this.photoEpoch = (this.photoEpoch || 0) + 1;
        this.photoMode = 'auto';
        this.photoHovered = false;
        this.photoRequested = false;
        const link = this.querySelector('[data-yfc-image]');
        const button = this.querySelector('[data-yfc-photo-toggle]');
        const secondary = link?.querySelector('.yfc-image--secondary');
        if (secondary && (!secondary.complete || secondary.naturalWidth === 0)) secondary.remove();
        if (button) button.hidden = !link?.querySelector('template[data-yfc-secondary]');
        this.updatePhoto();
      }
      updatePhoto() {
        const link = this.querySelector('[data-yfc-image]');
        const button = this.querySelector('[data-yfc-photo-toggle]');
        const media = link?.closest('.yfc-media');
        if (!link || !button || !media) return;
        const template = link.querySelector('template[data-yfc-secondary]');
        let secondary = link.querySelector('.yfc-image--secondary');
        this.photoRequested = Boolean(template && (this.photoMode === 'secondary' || (this.photoMode === 'auto' && this.photoHovered)));
        if (this.photoRequested && !secondary) {
          secondary = template.content.querySelector('img')?.cloneNode(true);
          if (secondary) {
            const epoch = this.photoEpoch;
            secondary.loading = 'eager';
            secondary.addEventListener('load', () => {
              if (epoch === this.photoEpoch && secondary.isConnected) this.updatePhoto();
            }, { once: true });
            secondary.addEventListener('error', () => {
              if (epoch !== this.photoEpoch || !secondary.isConnected) return;
              secondary.remove();
              this.photoMode = 'primary';
              this.updatePhoto();
              const status = this.querySelector('[data-yfc-status]');
              if (status) status.textContent = 'The alternate photo could not load. You can try again.';
            }, { once: true });
            link.append(secondary);
          }
        }
        const ready = Boolean(secondary?.complete && secondary.naturalWidth > 0);
        const active = this.photoRequested && ready;
        const changed = media.classList.contains('is-secondary-active') !== active;
        media.classList.toggle('is-secondary-active', active);
        link.querySelector('.yfc-image--primary')?.setAttribute('aria-hidden', String(active));
        secondary?.setAttribute('aria-hidden', String(!active));
        button.setAttribute('aria-pressed', String(this.photoRequested));
        button.setAttribute('aria-busy', String(this.photoRequested && !ready));
        const label = 'Alternate product photo';
        button.setAttribute('aria-label', label);
        button.title = label;
        if (changed && this.photoMode !== 'auto') {
          const status = this.querySelector('[data-yfc-status]');
          if (status) status.textContent = active ? 'Alternate product photo shown.' : 'Main product photo shown.';
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.photoEpoch = (this.photoEpoch || 0) + 1;
        this.choiceLinks = null;
        this.variantStates = null;
      }
    });
  }
  if (!customElements.get('yfc-size-guide')) {
    customElements.define('yfc-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const showPhoto = () => {
          const template = this.querySelector('template[data-yfc-guide-photo]');
          const target = this.querySelector('[data-yfc-guide-photo-target]');
          if (!this.querySelector('details')?.open || !template || !target || target.childNodes.length) return;
          const content = template.content.cloneNode(true);
          content.querySelector('img')?.addEventListener('error', () => { target.hidden = true; }, { once: true });
          target.append(content);
          target.hidden = false;
        };
        this.addEventListener('toggle', showPhoto, { capture: true, signal: this.controller.signal });
        showPhoto();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    if (customElements.get('sticky-header')) return;

    class StickyHeader extends HTMLElement {
      constructor() {
        super();

        this.queueScrollUpdate = this.queueScrollUpdate.bind(this);
        this.runScrollUpdate = this.runScrollUpdate.bind(this);
        this.queueLayoutUpdate = this.queueLayoutUpdate.bind(this);
        this.handleFocusIn = this.handleFocusIn.bind(this);

        this.hideHeaderOnScrollUp = () => {
          this.preventReveal = true;
        };

        this.scrollFrame = null;
        this.layoutFrame = null;
      }

      connectedCallback() {
        this.header = this.closest('.section-header');
        if (!this.header) return;

        this.headerIsAlwaysSticky = ['always', 'reduce-logo-size'].includes(
          this.dataset.stickyType
        );

        this.currentScrollTop = this.getScrollTop();
        this.scrollDirection = 0;
        this.scrollDistance = 0;
        this.preventReveal = false;
        this.headerBounds = null;

        // Measure the full header in document coordinates before making it sticky.
        this.header.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate',
          'scrolled-past-header'
        );

        this.setHeaderHeight();

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        this.addEventListener('focusin', this.handleFocusIn);
        this.addEventListener('load', this.queueLayoutUpdate, true);

        window.addEventListener('scroll', this.queueScrollUpdate, {
          passive: true
        });

        window.addEventListener('resize', this.queueLayoutUpdate, {
          passive: true
        });

        window.addEventListener('pageshow', this.queueLayoutUpdate);

        if ('ResizeObserver' in window) {
          this.headerObserver = new ResizeObserver(this.queueLayoutUpdate);
          this.headerObserver.observe(this.header);
        }

        this.queueLayoutUpdate();
        this.onScroll();
      }

      getScrollTop() {
        const maximum = Math.max(
          0,
          document.documentElement.scrollHeight - window.innerHeight
        );

        return Math.min(
          maximum,
          Math.max(
            0,
            window.scrollY || document.documentElement.scrollTop || 0
          )
        );
      }

      setHeaderHeight() {
        if (!this.header || !this.isConnected) return;

        const height = this.header.offsetHeight;
        const scrollTop = this.getScrollTop();
        let top = this.headerBounds ? this.headerBounds.top : 0;

        // A sticky element's viewport position is not its original page position.
        if (
          !this.headerBounds ||
          !this.header.classList.contains('shopify-section-header-sticky') ||
          scrollTop === 0
        ) {
          top = Math.max(
            0,
            this.header.getBoundingClientRect().top + scrollTop
          );
        }

        this.headerBounds = {
          top,
          bottom: top + height
        };

        const value = `${height}px`;

        if (
          document.documentElement.style.getPropertyValue('--header-height') !==
          value
        ) {
          document.documentElement.style.setProperty('--header-height', value);
        }
      }

      queueLayoutUpdate() {
        if (!this.isConnected || this.layoutFrame !== null) return;

        this.layoutFrame = requestAnimationFrame(() => {
          this.layoutFrame = null;

          if (!this.isConnected) return;

          // A queued scroll still needs its original position and accumulated movement.
          const hasPendingScroll = this.scrollFrame !== null;

          if (hasPendingScroll) {
            cancelAnimationFrame(this.scrollFrame);
            this.scrollFrame = null;
          }

          this.setHeaderHeight();

          if (!hasPendingScroll) {
            this.scrollDistance = 0;
            this.scrollDirection = 0;
            this.currentScrollTop = this.getScrollTop();
          }

          this.onScroll();
        });
      }

      disconnectedCallback() {
        this.removeEventListener(
          'preventHeaderReveal',
          this.hideHeaderOnScrollUp
        );

        this.removeEventListener('focusin', this.handleFocusIn);
        this.removeEventListener('load', this.queueLayoutUpdate, true);

        window.removeEventListener('scroll', this.queueScrollUpdate);
        window.removeEventListener('resize', this.queueLayoutUpdate);
        window.removeEventListener('pageshow', this.queueLayoutUpdate);

        if (this.scrollFrame !== null) {
          cancelAnimationFrame(this.scrollFrame);
        }

        if (this.layoutFrame !== null) {
          cancelAnimationFrame(this.layoutFrame);
        }

        this.scrollFrame = null;
        this.layoutFrame = null;

        window.clearTimeout(this.isScrolling);

        if (this.headerObserver) {
          this.headerObserver.disconnect();
        }

        this.headerObserver = null;
      }

      queueScrollUpdate() {
        if (!this.isConnected || this.scrollFrame !== null) return;

        this.scrollFrame = requestAnimationFrame(this.runScrollUpdate);
      }

      runScrollUpdate() {
        this.scrollFrame = null;

        if (this.isConnected) {
          this.onScroll();
        }
      }

      isPredictiveSearchOpen() {
        for (const search of this.querySelectorAll('predictive-search')) {
          if (search.isOpen) return true;
        }

        return false;
      }

      isInteracting() {
        const focused = document.activeElement;

        return (
          this.isPredictiveSearchOpen() ||
          Boolean(
            this.querySelector(
              'header-drawer details[open], details-modal details[open], localization-form [aria-expanded="true"]'
            )
          ) ||
          Boolean(
            focused &&
            this.contains(focused) &&
            focused.matches(':focus-visible')
          )
        );
      }

      handleFocusIn() {
        if (!this.isInteracting()) return;

        this.scrollDistance = 0;
        this.scrollDirection = 0;
        this.currentScrollTop = this.getScrollTop();

        this.reveal();
      }

      onScroll() {
        if (!this.headerBounds) return;

        const scrollTop = this.getScrollTop();
        const delta = scrollTop - this.currentScrollTop;

        this.currentScrollTop = scrollTop;

        if (scrollTop <= this.headerBounds.top) {
          if (this.header.classList.contains('scrolled-past-header')) {
            this.header.classList.remove('scrolled-past-header');
          }

          this.reset();
          this.scrollDistance = 0;
          this.scrollDirection = 0;

          return;
        }

        if (scrollTop <= this.headerBounds.bottom) {
          // Restore the normal header when scrolling back into its original area.
          // A large scroll step can skip the usual reveal branch below.
          this.header.classList.remove('scrolled-past-header');
          this.reset();
          this.scrollDistance = 0;
          this.scrollDirection = 0;

          return;
        }

        if (!this.header.classList.contains('scrolled-past-header')) {
          this.header.classList.add('scrolled-past-header');
        }

        if (this.headerIsAlwaysSticky) return;

        if (this.isInteracting()) {
          this.scrollDistance = 0;
          this.scrollDirection = 0;

          return;
        }

        if (delta === 0) return;

        if (delta < 0 && this.preventReveal) {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = window.setTimeout(() => {
            this.preventReveal = false;
          }, 66);
        }

        const direction = Math.sign(delta);

        if (direction !== this.scrollDirection) {
          this.scrollDistance = 0;
        }

        this.scrollDirection = direction;
        this.scrollDistance += Math.abs(delta);

        // Ignore trackpad/touch jitter; slow, deliberate movement still accumulates.
        if (this.scrollDistance < 8) return;

        this.scrollDistance = 0;

        if (direction > 0) {
          if (!this.preventHide) {
            this.hide();
          }
        } else if (this.preventReveal) {
          this.hide();
        } else {
          this.reveal();
        }
      }

      hide() {
        if (
          this.headerIsAlwaysSticky ||
          this.header.classList.contains('shopify-section-header-hidden')
        ) {
          return;
        }

        this.header.classList.add(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky'
        );

        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (
          this.headerIsAlwaysSticky ||
          (
            !this.header.classList.contains('shopify-section-header-hidden') &&
            this.header.classList.contains('animate')
          )
        ) {
          return;
        }

        this.header.classList.add(
          'shopify-section-header-sticky',
          'animate'
        );

        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;

        if (
          !this.header.classList.contains('shopify-section-header-hidden') &&
          !this.header.classList.contains('shopify-section-header-sticky') &&
          !this.header.classList.contains('animate')
        ) {
          return;
        }

        this.header.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate'
        );
      }

      closeMenuDisclosure() {
        this.header.querySelectorAll('header-menu').forEach((disclosure) => {
          if (typeof disclosure.close === 'function') {
            disclosure.close();
          }
        });
      }

      closeSearchModal() {
        this.header.querySelectorAll('details-modal').forEach((modal) => {
          if (typeof modal.close === 'function') {
            modal.close(false);
          }
        });
      }
    }

    customElements.define('sticky-header', StickyHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  if (!customElements.get('yatskia-collection-description')) {
    customElements.define('yatskia-collection-description', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.init());
      }

      init() {
        this.content = this.querySelector('[data-yu-content]');
        this.preview = this.querySelector('[data-yu-preview]');
        this.button = this.querySelector('[data-yu-toggle]');
        this.label = this.querySelector('[data-yu-label]');
        this.viewport = this.querySelector('[data-yu-viewport]');
        if (!this.content || !this.button || this.dataset.enabled === 'false') return;

        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.expanded = Boolean(window.Shopify && window.Shopify.designMode);

        // Build an excerpt from text, never from embedded CSS or JavaScript.
        const copy = this.content.cloneNode(true);
        copy.querySelectorAll('style, script, noscript, template, svg').forEach(node => node.remove());
        const firstParagraph = Array.from(copy.querySelectorAll('p')).find(node => node.textContent.trim());
        const text = (firstParagraph || copy).textContent.replace(/\s+/g, ' ').trim();
        const words = text.split(' ');
        const limit = Math.max(20, Math.min(60, Number(this.dataset.previewWords) || 40));
        this.preview.textContent = words.length > limit
          ? words.slice(0, limit).join(' ').replace(/[.,;:]$/, '') + '…'
          : text;

        this.button.addEventListener('click', () => this.toggle(!this.expanded), options);
        this.content.addEventListener('load', () => this.scheduleMeasure(), { ...options, capture: true });
        window.addEventListener('resize', () => this.scheduleMeasure(), options);
        this.closest('.shopify-section')?.addEventListener('shopify:section:select', () => {
          this.toggle(true, false);
        }, options);

        if ('ResizeObserver' in window) {
          this.lastWidth = this.getBoundingClientRect().width;
          this.observer = new ResizeObserver(entries => {
            const width = entries[0].contentRect.width;
            if (Math.abs(width - this.lastWidth) > 1) {
              this.lastWidth = width;
              this.scheduleMeasure();
            }
          });
          this.observer.observe(this);
        }
        this.measure();
        document.fonts?.ready.then(() => {
          if (this.isConnected && this.events) this.scheduleMeasure();
        });
      }

      scheduleMeasure() {
        cancelAnimationFrame(this.measureFrame);
        this.measureFrame = requestAnimationFrame(() => this.measure());
      }

      measure() {
        if (!this.isConnected) return;
        this.stopAnimation();
        // Temporarily measure hidden content, then restore it before painting.
        this.preview.hidden = true;
        this.content.hidden = false;
        this.canCollapse = Boolean(this.preview.textContent.trim()) && this.content.getBoundingClientRect().height > 150;
        if (!this.canCollapse) this.expanded = true;
        this.render();
      }

      render() {
        const open = this.expanded || !this.canCollapse;
        this.content.hidden = !open;
        this.preview.hidden = open;
        this.button.hidden = !this.canCollapse;
        this.button.setAttribute('aria-expanded', String(open));
        this.label.textContent = open ? this.dataset.less : this.dataset.more;
      }

      toggle(open, animate = true) {
        if (!this.canCollapse) return;
        const from = this.viewport.getBoundingClientRect().height;
        const returnToStart = !open && this.getBoundingClientRect().top < 0;
        this.stopAnimation();
        this.expanded = open;
        this.render();
        const to = this.viewport.getBoundingClientRect().height;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const finish = () => {
          this.animation = null;
          this.viewport.style.removeProperty('overflow');
          if (returnToStart) this.scrollIntoView({ block: 'start', behavior: reducedMotion ? 'auto' : 'smooth' });
        };

        if (animate && !reducedMotion && this.viewport.animate && Math.abs(from - to) > 1) {
          this.viewport.style.overflow = 'hidden';
          this.animation = this.viewport.animate(
            [{ height: from + 'px' }, { height: to + 'px' }],
            { duration: 320, easing: 'cubic-bezier(.2,.7,.2,1)' }
          );
          this.animation.onfinish = finish;
        } else {
          finish();
        }
        // At rest, height is always automatic. FAQs and images can grow freely.
      }

      stopAnimation() {
        if (this.animation) {
          this.animation.onfinish = null;
          this.animation.cancel();
          this.animation = null;
        }
        this.viewport?.style.removeProperty('overflow');
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.measureFrame);
        this.events?.abort();
        this.events = null;
        this.observer?.disconnect();
        this.stopAnimation();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function() {
  "use strict";
  var e = "__yatskiaPersonalizationV7";
  if (window[e]) {
    window[e].init(document);
    return
  }
  var t = new Map;
  var r = 'form[action*="/cart/add"]';
  var n = ["Personalization", "Design Placement", "Engraving Name", "Date of Birth", "Date of Passing", "Memorial Message", "Design Notes", "Portrait Photo", "AI Preview Status", "AI Design Preview", "_AI Preview", "_AI Preview ID", "_AI Reference Photo", "_AI Draft Preview", "_Personalization Mode", "_Personalization Submission"];

  function a(e) {
    var t = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (t || "/").replace(/\/?$/, "/") + e
  }

  function openConfirmedCart() {
    var cartUrl = a("cart");
    try {
      // The cart page consumes this once. No personalization details are stored.
      window.sessionStorage.setItem("yatskia:cart-arrival:v1", JSON.stringify({
        at: Date.now(),
        path: cartUrl
      }));
    } catch (_) {
      // Optional animation storage must never prevent the cart redirect.
    }
    location.assign(cartUrl)
  }

  function i(e) {
    try {
      var t = new URL(e, location.origin);
      return e && t.protocol === "https:" && !t.username && !t.password ? t.href : ""
    } catch (e) {
      return ""
    }
  }

  function o(e) {
    return e && (e.form || document.getElementById(e.getAttribute("form")) || e.closest(r))
  }

  function s(e) {
    t.forEach(function(e, t) {
      if (!t.isConnected) e.destroy()
    });
    if (e.matches && e.matches(".y-personalization")) u(e);
    if (e.querySelectorAll) e.querySelectorAll(".y-personalization").forEach(u)
  }

  function l(e) {
    if (!e || !e.matches || !e.matches(r)) return null;
    var n = null;
    t.forEach(function(t, r) {
      if (r.isConnected && t.owns(e)) n = t
    });
    return n
  }

  function u(e) {
    if (t.has(e) || !e.querySelector("[data-y-mode]")) return;
    var o = function(t) {
      return e.querySelector(t)
    };
    var s = e.closest("product-info") || e.closest('[id^="shopify-section-"]') || e.parentElement;
    var modeInputs = Array.from(e.querySelectorAll("[data-y-mode]"));
    var activeMode = "none";
    var modeLabels = {
      none: "Original design",
      text: "Text only",
      photo: "Photo only",
      both: "Text + photo"
    };
    var notesDrafts = {
      none: "",
      text: "",
      photo: "",
      both: ""
    };
    var lastValidationTarget = null;
    var textFields = o("[data-y-text-fields]");
    var photoFields = o("[data-y-photo-fields]");
    var modeAnnouncement = o("[data-y-mode-announcement]");

    function includesText(mode) {
      return mode === "text" || mode === "both"
    }

    function includesPhoto(mode) {
      return mode === "photo" || mode === "both"
    }

    function failValidation(message, target) {
      lastValidationTarget = target || null;
      return message
    }
    var u = o(".y-fields");
    var c = o("[data-y-upload]");
    var f = o("[data-y-design-notes]");
    var d = o("[data-y-message]");
    var p = o('[name="properties[Engraving Name]"]');
    var h = o('[name="properties[Date of Birth]"]');
    var m = o('[name="properties[Date of Passing]"]');
    var v = o("[data-yai-generate]");
    var y = o("[data-yai-regenerate]");
    var g = o("[data-yai-use]");
    var b = o("[data-yai-remove]");
    var w = o("[data-yai-image]");
    var P = o("[data-yai-card]");
    var A = o("[data-yai-attached]");
    var E = o("[data-yai-attached-thumb]");
    var k = o("[data-yai-error]");
    var S = o("[data-yai-help]");
    var C = o("[data-y-confirm]");
    var I = o("[data-yai-variant-images]");
    var removePhoto = o("[data-y-remove-upload]");
    var totalCounter = o("[data-y-engraving-total]");
    var comboNote = o("[data-y-combo-note]");
    var messageCounter = o("[data-y-char-count]");
    var notesCounter = o("[data-y-notes-count]");
    var editorValues = new WeakMap;
    var bindingsDirty = true,
      formCandidates = [],
      checkoutButtons = [],
      cachedMainForm = null;
    var variantRules = {};
    try {
      variantRules = JSON.parse(o("[data-yai-variant-rules]").textContent)
    } catch (_) {}
    var segmenter = typeof Intl.Segmenter === "function" ? new Intl.Segmenter(undefined, {
      granularity: "grapheme"
    }) : null;

    function characterCount(text) {
      return segmenter ? Array.from(segmenter.segment(text)).length : Array.from(text).length
    }

    function engravingText(state) {
      return [state.name, [ce(state.birth), ce(state.passing)].filter(Boolean).join(" – "), state.message].filter(Boolean).join("\n")
    }

    function engravingLimit(state) {
      return Number(variantRules[state.variant]?.limit) || 40
    }

    function updateLimits(state) {
      state = state || oe();
      var limit = engravingLimit(state),
        used = characterCount(engravingText(state));
      var counter = totalCounter;
      if (counter) {
        var message = used + " / " + limit + " engraving characters";
        if (counter.textContent !== message) counter.textContent = message;
        counter.classList.toggle("is-over-limit", used > limit)
      }
      var combo = comboNote;
      if (combo) combo.hidden = !variantRules[state.variant]?.combo;
      var today = new Date,
        maxDate = today.getFullYear() + "-" + String(today.getMonth() + 1).padStart(2, "0") + "-" + String(today.getDate()).padStart(2, "0");
      if (h.max !== maxDate) h.max = maxDate;
      if (m.max !== maxDate) m.max = maxDate;
      var invalid = String(state.enabled && used > limit);
      if (p.getAttribute("aria-invalid") !== invalid) p.setAttribute("aria-invalid", invalid);
      if (d.getAttribute("aria-invalid") !== invalid) d.setAttribute("aria-invalid", invalid);
      if (k.dataset.validationError === "true") {
        var currentError = Ae(state);
        if (currentError) de(currentError, false, false, false);
        else fe()
      }
    }
    if (!modeInputs.length || !textFields || !photoFields || !u || !c || !f || !d || !v) return;
    var U = {};
    try {
      U = JSON.parse(I.textContent)
    } catch (e) {}
    var x = false,
      D = false,
      z = false,
      q = false;
    var N = 0,
      T = null,
      _ = null,
      M = null;
    var j = null,
      R = false,
      O = false;
    var F = "",
      G = null,
      J = null;
    var photoCheckVersion = 0;
    var pendingPhotoFile = null;
    var validatedPhotoFile = null;
    var B = "",
      W = null,
      Y = [];
    var V = new Map,
      H = new Map,
      $ = [];
    var K = Array.from(u.querySelectorAll('[name^="properties["]')).map(function(e) {
      var t = e.getAttribute("form");
      e.setAttribute("form", "yai-editor-" + modeInputs[0].id);
      return [e, t]
    });
    var Q = 25 * 1024 * 1024;
    var X = 'variant-selects input, variant-selects select, [data-option-selector] input, [data-option-selector] select, [name^="options["]';

    function ee(e, t, r, n) {
      e.addEventListener(t, r, n);
      $.push(function() {
        e.removeEventListener(t, r, n)
      })
    }

    function te(e) {
      return e ? e.value.trim() : ""
    }

    function re(e) {
      var t = e && e.elements.namedItem("id");
      return t && t.value ? String(t.value) : ""
    }

    function ne(t) {
      if (!t || !s.contains(t) || /installment/.test(t.getAttribute("id") || "")) return false;
      var r = t.closest("product-info") || t.closest('[id^="shopify-section-"]');
      if (r && r !== s && !r.contains(e)) return false;
      // Keep the primary form guarded even if its variant metadata is unavailable.
      return t.id === "product-form-" + s.dataset.section || Object.prototype.hasOwnProperty.call(U, re(t))
    }

    function ae() {
      if (cachedMainForm && cachedMainForm.isConnected && ne(cachedMainForm)) return cachedMainForm;
      var t = e.closest(r);
      if (t && !/installment/.test(t.getAttribute("id") || "")) return t;
      var n = s.querySelectorAll(r);
      for (var a = 0; a < n.length; a++) {
        if (!/installment/.test(n[a].getAttribute("id") || "") && n[a].querySelector('[name="add"], [type="submit"]') && ne(n[a])) return cachedMainForm = n[a]
      }
      return null
    }

    function ie() {
      return Array.from(s.querySelectorAll(X)).filter(function(e) {
        return e.type !== "radio" || e.checked
      }).map(function(e) {
        return [e.name || e.id, e.value]
      })
    }

    function oe(form) {
      var text = includesText(activeMode),
        photo = includesPhoto(activeMode);
      return {
        enabled: activeMode !== "none",
        mode: activeMode,
        variant: re(form || ae()),
        options: ie(),
        name: text ? te(p) : "",
        birth: text ? te(h) : "",
        passing: text ? te(m) : "",
        message: text ? te(d) : "",
        notes: activeMode !== "none" ? te(f) : "",
        photo: photo && c.files ? c.files[0] || null : null
      }
    }

    function se(e) {
      var t = e.photo;
      return JSON.stringify([e.enabled, e.mode, e.variant, e.options, e.name, e.birth, e.passing, e.message, e.notes, t ? [t.name, t.size, t.type, t.lastModified] : null])
    }

    function le(e, t) {
      var r = oe(t);
      return se(r) === se(e) && r.photo === e.photo
    }

    function ue(e) {
      return j && j.signature === se(e) && j.photo === e.photo ? j : null
    }

    function ce(e) {
      if (!e) return "";
      var t = e.split("-");
      var r = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      return t.length === 3 && r[Number(t[1]) - 1] ? r[Number(t[1]) - 1] + " " + Number(t[2]) + ", " + t[0] : e
    }

    function clearFieldErrors() {
      e.querySelectorAll("[data-y-field-error]").forEach(function(node) {
        node.textContent = "";
        node.hidden = true
      });
      K.forEach(function(entry) {
        entry[0].removeAttribute("aria-invalid")
      })
    }

    function fe() {
      delete k.dataset.validationError;
      k.textContent = "";
      k.classList.remove("show");
      clearFieldErrors();
      S.style.display = "none";
      o("[data-y-check-cart]").hidden = true
    }

    function de(message, serviceError, checkCart, focus) {
      k.dataset.validationError = String(!serviceError && !checkCart);
      clearFieldErrors();
      var target = !serviceError && !checkCart ? lastValidationTarget : null;
      var group = target && target.closest("[data-y-field-group]");
      var inlineError = group && group.querySelector("[data-y-field-error]");
      k.textContent = inlineError ? "" : message;
      k.classList.toggle("show", !inlineError);
      k.tabIndex = -1;
      if (inlineError) {
        inlineError.textContent = message;
        inlineError.hidden = false;
        target.setAttribute("aria-invalid", "true");
        if (group.tagName === "DETAILS") group.open = true
      }
      S.style.display = serviceError ? "flex" : "none";
      o("[data-y-check-cart]").hidden = !checkCart;
      if (focus !== false) {
        var anchor = target || k;
        anchor.focus({
          preventScroll: true
        });
        (inlineError || k).scrollIntoView({
          block: "nearest",
          behavior: "auto"
        })
      }
    }

    function pe() {
      W = null;
      C.hidden = true
    }

    function he(state) {
      updateLimits(state);
      var messageLength = String(d.value.length),
        notesLength = String(f.value.length);
      if (messageCounter.textContent !== messageLength) messageCounter.textContent = messageLength;
      if (notesCounter.textContent !== notesLength) notesCounter.textContent = notesLength
    }

    function me(e) {
      q = e;
      if (_) clearInterval(_);
      _ = null;
      v.disabled = e || D;
      y.disabled = e || D;
      v.classList.toggle("gen", e);
      var t = o("[data-yai-button-text]");
      if (!e) {
        t.textContent = "Generate AI preview (optional)";
        return
      }
      var r = Date.now();
      var n = ["Setting up your design…", "Placing your personalization on the urn…", "Blending it with the original design…", "Checking the layout…", "Almost there. Finishing touches…"];
      var a = function() {
        t.textContent = n[Math.min(n.length - 1, Math.floor((Date.now() - r) / 14e3))]
      };
      a();
      _ = setInterval(a, 14e3)
    }

    function ve() {
      N++;
      if (T) T.abort();
      T = null;
      if (M) clearTimeout(M);
      M = null;
      me(false);
      j = null;
      R = false;
      O = false;
      P.classList.remove("show");
      w.removeAttribute("src");
      A.classList.remove("show");
      E.removeAttribute("src");
      g.classList.remove("locked");
      g.textContent = "Use this preview";
      o("[data-y-preview-status]").textContent = "AI preview: not selected";
      g.disabled = true;
      pe();
      Ce()
    }

    function ye(e) {
      if (!e) return "";
      if (!e.size) return "This photo is empty. Please choose another JPG, PNG or WebP image.";
      if (e.size > Q) return "Please choose a photo smaller than 25 MB.";
      if (/\.(heic|heif)$/i.test(e.name) || /image\/hei[cf]/i.test(e.type)) return "Please convert this HEIC/HEIF photo to JPG, PNG or WebP before uploading.";
      if (e.type ? !/^image\/(jpeg|png|webp)$/i.test(e.type) : !/\.(jpe?g|png|webp)$/i.test(e.name)) return "Please choose a JPG, PNG or WebP photo.";
      return ""
    }

    function ge() {
      var checkVersion = ++photoCheckVersion;
      pendingPhotoFile = null;
      validatedPhotoFile = null;
      if (F) URL.revokeObjectURL(F);
      F = "";
      G = null;
      J = null;
      var file = c.files && c.files[0];
      var thumbnail = o("[data-y-preview-image]");
      var status = o("[data-y-photo-status]");
      var selection = o("[data-y-upload-success]");
      if (removePhoto) removePhoto.hidden = !file;
      thumbnail.hidden = true;
      thumbnail.removeAttribute("src");
      selection.style.display = file ? "flex" : "none";
      o("[data-y-file-name]").textContent = file ? file.name : "No image selected";
      o("[data-y-upload-title]").textContent = file ? "Replace photo" : "Upload a photo";
      B = ye(file);
      status.classList.toggle("is-error", !!B);
      status.textContent = B ? "Choose another photo." : file ? "Checking your photo…" : "";
      if (B) {
        if (includesPhoto(activeMode)) {
          lastValidationTarget = c;
          de(B, false, false, false)
        }
        return
      }
      if (!file) return;
      pendingPhotoFile = file;
      F = URL.createObjectURL(file);
      var localUrl = F;
      var inspector = new Image;

      function finishPhotoCheck(readable) {
        inspector.onload = inspector.onerror = null;
        if (x || checkVersion !== photoCheckVersion || c.files[0] !== file) return;
        pendingPhotoFile = null;
        validatedPhotoFile = readable ? file : null;
        B = readable ? "" : "This photo could not be opened. Please choose another JPG, PNG or WebP image.";
        status.classList.toggle("is-error", !readable);
        status.textContent = readable ? "Photo ready. Saved when you add to cart." : "This photo could not be opened.";
        if (readable) {
          thumbnail.src = localUrl;
          thumbnail.hidden = false
        } else if (includesPhoto(activeMode)) {
          lastValidationTarget = c;
          de(B, false, false, false)
        }
        Ce()
      }
      inspector.onload = function() {
        finishPhotoCheck(inspector.naturalWidth > 0 && inspector.naturalHeight > 0)
      };
      inspector.onerror = function() {
        finishPhotoCheck(false)
      };
      inspector.src = localUrl
    }

    function be(e) {
      if (!e) return Promise.resolve(null);
      if (e === G && J) return J;
      G = e;
      J = new Promise(function(t, r) {
        var n = URL.createObjectURL(e),
          a = new Image;
        a.onload = function() {
          URL.revokeObjectURL(n);
          try {
            var e = a.naturalWidth,
              i = a.naturalHeight;
            if (!e || !i) throw new Error("Could not read this photo. Please choose another image.");
            var o = Math.min(1, 1600 / Math.max(e, i));
            var s = document.createElement("canvas");
            s.width = Math.max(1, Math.round(e * o));
            s.height = Math.max(1, Math.round(i * o));
            var l = s.getContext("2d");
            if (!l) throw new Error("Your browser could not prepare the photo. Please try another browser.");
            l.fillStyle = "#fff";
            l.fillRect(0, 0, s.width, s.height);
            l.drawImage(a, 0, 0, s.width, s.height);
            s.toBlob(function(e) {
              e ? t(e) : r(new Error("Could not prepare the photo."))
            }, "image/jpeg", .86)
          } catch (e) {
            r(e)
          }
        };
        a.onerror = function() {
          URL.revokeObjectURL(n);
          r(new Error("Could not read this photo. Please choose another JPG, PNG or WebP image."))
        };
        a.src = n
      });
      J.catch(function() {
        if (G === e) J = null
      });
      return J
    }

    function we(e, t) {
      return new Promise(function(r, n) {
        function a() {
          n(new Error("Photo preparation was cancelled."))
        }
        if (t.aborted) {
          a();
          return
        }
        t.addEventListener("abort", a, {
          once: true
        });
        be(e).then(function(e) {
          t.removeEventListener("abort", a);
          r(e)
        }, function(e) {
          t.removeEventListener("abort", a);
          n(e)
        })
      })
    }

    function Pe(t) {
      var r = U[t.variant] || e.dataset.yaiUrnImage || "";
      if (!r) {
        var n = s.querySelectorAll(".product__media-item.is-active img, [data-product-media] img, .product-gallery img");
        for (var a = 0; a < n.length; a++) {
          if (n[a].getClientRects().length && !n[a].closest('[hidden], [aria-hidden="true"]')) {
            r = n[a].currentSrc || n[a].src;
            break
          }
        }
      }
      if (r.indexOf("//") === 0) r = "https:" + r;
      if (/^https?:\/\/cdn\.shopify\.com\/files\//i.test(r)) {
        var i = s.querySelectorAll("img");
        for (var o = 0; o < i.length; o++) {
          var l = (i[o].currentSrc || i[o].src || "").match(/https:\/\/cdn\.shopify\.com\/s\/files\/1\/\d+\/\d+\/\d+\//);
          if (l) {
            r = r.replace(/^https?:\/\/cdn\.shopify\.com\//i, l[0]);
            break
          }
        }
      }
      try {
        var u = new URL(r, location.origin);
        if (!r || u.protocol !== "https:") return "";
        u.searchParams.set("width", "1024");
        return u.href
      } catch (e) {
        return ""
      }
    }

    // The editor lives outside the product form, so validate date values here.
    // Compare numeric dates: years can exceed four digits in native date inputs.
    function dateProblem(input, value) {
      if (input.validity.badInput) return "Please enter a complete, valid date.";
      if (!value) return "";
      var time = input.valueAsNumber;
      if (!Number.isFinite(time)) return "Please enter a complete, valid date.";
      var today = new Date();
      var midnightUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
      return time > midnightUTC ? "Please check the date. It cannot be in the future." : "";
    }

    // A custom submit must respect the native theme's loading/availability state.
    function cartReadiness(form) {
      if (!form || !form.isConnected || !ne(form)) return "Please refresh the page before adding this urn.";
      var variantInput = form.elements.namedItem("id");
      if (!variantInput || !variantInput.value || variantInput.disabled) return "Please select an available urn option first.";
      var button = form.querySelector('[name="add"], button[type="submit"], input[type="submit"]');
      if (form.getAttribute("aria-busy") === "true" || button && (button.disabled || button.getAttribute("aria-disabled") === "true" || button.getAttribute("aria-busy") === "true" || button.classList.contains("loading"))) {
        return "This option is unavailable or still updating. Wait for Add to cart to become available.";
      }
      return "";
    }

    function Ae(state) {
      lastValidationTarget = null;
      if (!state.variant) return failValidation("Please select an available urn option first.");
      if (!state.enabled) return "";
      if (!Object.prototype.hasOwnProperty.call(variantRules, state.variant)) return failValidation("Personalization settings for this option are unavailable. Please refresh the page or contact our team before ordering.");
      if (state.notes.length > 300) return failValidation("Please keep placement notes within 300 characters.", f);
      if (includesText(state.mode)) {
        var birthError = dateProblem(h, state.birth);
        var passingError = dateProblem(m, state.passing);
        if (birthError || passingError) return failValidation(birthError || passingError, birthError ? h : m);
        if (!state.name && !state.birth && !state.passing && !state.message) return failValidation("Add a name, date, or short tribute to continue with " + modeLabels[state.mode] + ".", p);
        if (state.message.length > 30) return failValidation("Please keep your tribute within 30 characters.", d);
        if (state.birth && state.passing && h.valueAsNumber > m.valueAsNumber) return failValidation("The birth date must be on or before the passing date.", m);
        if (characterCount(engravingText(state)) > engravingLimit(state)) return failValidation("Please shorten your text to " + engravingLimit(state) + " engraving characters for this size. Spaces and displayed dates count.", p)
      }
      if (includesPhoto(state.mode)) {
        if (!state.photo) return failValidation("Upload a photo to continue with " + modeLabels[state.mode] + ".", c);
        var photoError = ye(state.photo) || B;
        if (photoError) return failValidation(photoError, c);
        if (pendingPhotoFile === state.photo || validatedPhotoFile !== state.photo) return failValidation("Your photo is still being checked. Please wait a moment, then try again.", c)
      }
      return ""
    }
    async function Ee() {
      if (D || q || activeMode === "none") return;
      fe();
      var t = oe(),
        r = Ae(t);
      if (r) {
        de(r);
        return
      }
      if (!e.dataset.yaiEndpoint) {
        de("The preview service is not configured. You can still add your personalization details.", true);
        return
      }
      ve();
      var n = N;
      var a = new AbortController;
      T = a;
      var o = false;
      me(true);
      M = setTimeout(function() {
        o = true;
        a.abort()
      }, 9e4);
      try {
        var s = await we(t.photo, a.signal);
        if (x || n !== N || !le(t)) return;
        if (a.signal.aborted) throw new Error("The preview took too long. Please try again.");
        var u = engravingText(t);
        var modeRule = t.mode === "photo" ? "Photo-only personalization. Use the supplied photo. Do not add any names, dates, captions, letters or other new text. " : t.mode === "text" ? "Text-only personalization. Do not add a portrait, person or extra image. " : "Text and photo personalization. Use the supplied photo and exact supplied inscription. ";
        var c = t.notes ? "Customer placement instructions: " + t.notes + ". These are placement instructions, not inscription text. They must not change the selected personalization mode. " : "Choose a balanced, readable placement for only the supplied personalization. ";
        var f = "Create a personalization preview on this exact " + (e.dataset.yaiProductTitle || "memorial urn") + ". " + modeRule + c + "Preserve the original urn shape, color and artwork. Never invent customer details. " + (u ? "Use only this exact inscription, without changing it: " + u : "No added inscription is requested.");
        var d = new FormData;
        if (s) d.append("photo", s, "portrait.jpg");
        d.append("description", f);
        d.append("style", "photorealistic");
        d.append("layout", e.dataset.yaiLayout || "theme-blend");
        var p = Pe(t);
        if (p) d.append("urn_image_url", p);
        if (u) d.append("name", u);
        d.append("notes", modeRule + c);
        if (e.dataset.yaiUrnRules) d.append("urn_rules", e.dataset.yaiUrnRules);
        var h = await fetch(e.dataset.yaiEndpoint, {
          method: "POST",
          body: d,
          signal: a.signal
        });
        var m;
        try {
          m = await h.json()
        } catch (e) {
          throw new Error("The preview service returned an unreadable response. Please try again.")
        }
        if (!h.ok) throw new Error("The preview service could not complete this request. Please try again.");
        if (x || n !== N || !le(t)) return;
        var v = m && typeof m.imageUrl === "string" ? i(m.imageUrl) : "";
        if (!v) throw new Error("The preview service did not return a valid image link.");
        j = {
          imageUrl: v,
          referenceUrl: m.referenceUrl ? i(m.referenceUrl) : "",
          previewId: typeof m.previewId === "string" ? m.previewId : "",
          signature: se(t),
          photo: t.photo
        };
        R = false;
        O = false;
        g.disabled = true;
        w.src = v;
        P.classList.add("show");
        Ce()
      } catch (e) {
        if (x || n !== N) return;
        console.error("[Yatskia personalization]", o ? "Preview timed out" : "Preview request failed");
        de(o ? "The preview took too long. Please try again, or add your details without a preview." : e.message || "Could not create the preview. Please try again.", true)
      } finally {
        if (n === N) {
          clearTimeout(M);
          M = null;
          T = null;
          me(false);
          if (W) qe(W.form)
        }
      }
    }

    function ke() {
      if (D || q || !O || !ue(oe())) return false;
      R = true;
      g.classList.add("locked");
      g.textContent = "Preview selected";
      o("[data-y-preview-status]").textContent = "AI preview: selected";
      E.src = j.imageUrl;
      A.classList.add("show");
      Ce();
      return true
    }

    function Se(state, submissionId) {
      if (!state.enabled) return {
        Personalization: "Original design"
      };
      var properties = {
        Personalization: modeLabels[state.mode],
        "_Personalization Mode": state.mode
      };
      if (state.name) properties["Engraving Name"] = state.name;
      if (state.birth) properties["Date of Birth"] = ce(state.birth);
      if (state.passing) properties["Date of Passing"] = ce(state.passing);
      if (state.message) properties["Memorial Message"] = state.message;
      if (state.notes) properties["Design Notes"] = state.notes;
      if (state.photo) properties["Portrait Photo"] = state.photo;
      var preview = ue(state),
        approved = !!(R && preview);
      if (approved) {
        properties["AI Design Preview"] = preview.imageUrl;
        properties["_AI Preview"] = preview.imageUrl;
        if (preview.previewId) properties["_AI Preview ID"] = preview.previewId;
        if (state.photo && preview.referenceUrl) properties["_AI Reference Photo"] = preview.referenceUrl
      }
      properties["Design Placement"] = approved ? "Follow selected AI preview and supplied details" : state.notes ? "Follow Design Notes" : "Standard layout for supplied details";
      properties["AI Preview Status"] = approved ? "Selected by customer" : "Not selected - use supplied details only";
      if (submissionId) properties["_Personalization Submission"] = submissionId;
      return properties
    }

    function Le(e, t) {
      n.forEach(function(t) {
        e.delete("properties[" + t + "]")
      });
      Object.keys(t).forEach(function(r) {
        var n = t[r];
        if (n instanceof File) e.set("properties[" + r + "]", n, n.name);
        else e.set("properties[" + r + "]", n)
      })
    }
    var orderSyncFrame = 0;

    function Ce() {
      if (x || orderSyncFrame) return;
      orderSyncFrame = requestAnimationFrame(syncOrderProperties)
    }

    function syncOrderProperties() {
      cancelAnimationFrame(orderSyncFrame);
      orderSyncFrame = 0;
      if (x) return;
      // Read editor/options once for this frame; formdata still reads live values.
      var editorState = oe();
      he(editorState);
      if (bindingsDirty) {
        formCandidates = Array.from(s.querySelectorAll(r));
        checkoutButtons = Array.from(s.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"], shopify-accelerated-checkout'));
        bindingsDirty = false
      }
      V.forEach(function(e, t) {
        if (!t.isConnected || !ne(t)) {
          e.cleanup();
          V.delete(t)
        }
      });
      formCandidates.forEach(function(e) {
        if (!ne(e)) return;
        var t = V.get(e);
        if (!t) {
          var r = document.createElement("div");
          r.hidden = true;
          r.setAttribute("data-y-order-properties", "");
          e.appendChild(r);
          var n = e.getAttribute("enctype");
          e.setAttribute("enctype", "multipart/form-data");
          var a = function(t) {
            if (!x && ne(e)) Le(t.formData, Se(oe(e)))
          };
          e.addEventListener("formdata", a);
          t = {
            box: r,
            fingerprint: "",
            photo: null,
            cleanup: function() {
              e.removeEventListener("formdata", a);
              r.remove();
              if (n === null) e.removeAttribute("enctype");
              else e.setAttribute("enctype", n)
            }
          };
          V.set(e, t)
        }
        var i = Object.assign({}, editorState, { variant: re(e) }),
          o = Se(i);
        var s = JSON.stringify(o);
        if (t.fingerprint === s && t.photo === i.photo && t.box.parentElement === e) return;
        if (t.box.parentElement !== e) e.appendChild(t.box);
        var l = document.createDocumentFragment();
        Object.keys(o).forEach(function(e) {
          var t = document.createElement("input");
          t.name = "properties[" + e + "]";
          if (o[e] instanceof File) {
            t.type = "file";
            t.hidden = true;
            try {
              t.files = c.files
            } catch (e) {}
          } else {
            t.type = "hidden";
            t.value = o[e]
          }
          if (e === "Personalization") t.setAttribute("data-y-status-property", "");
          l.appendChild(t)
        });
        t.box.replaceChildren(l);
        t.fingerprint = s;
        t.photo = i.photo
      });
      H.forEach(function(value, node) {
        if (!node.isConnected) H.delete(node)
      });
      checkoutButtons.forEach(function(e) {
        if (!H.has(e)) H.set(e, {
          display: e.style.getPropertyValue("display"),
          priority: e.style.getPropertyPriority("display"),
          hidden: e.hidden,
          inert: e.hasAttribute("inert")
        });
        var blocked = activeMode !== "none" || D || z,
          previous = H.get(e);
        if (blocked) {
          e.setAttribute("data-y-checkout-blocked", "");
          e.hidden = true;
          e.setAttribute("inert", "");
          if (e.style.getPropertyValue("display") !== "none" || e.style.getPropertyPriority("display") !== "important") e.style.setProperty("display", "none", "important")
        } else {
          e.removeAttribute("data-y-checkout-blocked");
          e.hidden = previous.hidden;
          e.toggleAttribute("inert", previous.inert);
          if (previous.display) e.style.setProperty("display", previous.display, previous.priority);
          else e.style.removeProperty("display")
        }
      })
    }

    function Ie() {
      var enabled = activeMode !== "none",
        text = includesText(activeMode),
        photo = includesPhoto(activeMode);
      u.hidden = !enabled;
      u.style.display = enabled ? "block" : "none";
      u.setAttribute("aria-hidden", String(!enabled));
      textFields.hidden = !text;
      photoFields.hidden = !photo;
      e.classList.toggle("is-open", enabled);
      e.dataset.personalizationMode = activeMode;
      K.forEach(function(entry) {
        var field = entry[0];
        field.disabled = D || !enabled || textFields.contains(field) && !text || photoFields.contains(field) && !photo
      });
      o("[data-y-proof-note]").hidden = !photo;
      o("[data-y-notes-help]").textContent = text && photo ? "Tell us where to place your text and photo. These notes are instructions, not text to print." : photo ? "Tell us where to place your photo. No added text is included with Photo only." : "Tell us where to place your text. No added photo is included with Text only.";
      f.placeholder = photo && !text ? "Example: center the photo on the front." : text && !photo ? "Example: name above the dates, tribute below." : "Example: photo above the name and dates.";
      bindingsDirty = true;
      syncOrderProperties()
    }

    function Ue(t) {
      D = t;
      if (t) {
        Y = [];
        var n = new Set(Array.from(e.querySelectorAll("input, textarea, button")));
        s.querySelectorAll(X).forEach(function(e) {
          n.add(e)
        });
        s.querySelectorAll(r).forEach(function(e) {
          if (ne(e)) Array.from(e.elements).forEach(function(e) {
            if (e.type !== "hidden") n.add(e)
          })
        });
        n.forEach(function(e) {
          Y.push([e, e.disabled]);
          e.disabled = true
        })
      } else {
        Y.forEach(function(e) {
          if (e[0].isConnected) e[0].disabled = e[1]
        });
        Y = []
      }
      e.setAttribute("aria-busy", String(t));
      Ce()
    }

    function normalizePropertyText(value) {
      // Multipart form text may be returned with CRLF rather than textarea LF.
      return String(value == null ? "" : value).replace(/\r\n?/g, "\n");
    }

    function xe(e, t, r, n) {
      if (!e || String(e.variant_id || e.id) !== r.variant || Number(e.quantity) !== n || !e.properties) return false;
      return Object.keys(t).every(function(r) {
        var n = e.properties[r];
        return t[r] instanceof File ? typeof n === "string" && !!i(n) && n !== t[r].name : normalizePropertyText(n) === normalizePropertyText(t[r])
      })
    }
    async function De(e) {
      var t = new AbortController;
      var r = setTimeout(function() {
        t.abort()
      }, 12e3);
      try {
        var n = await fetch(a("cart.js"), {
          headers: {
            Accept: "application/json"
          },
          cache: "no-store",
          signal: t.signal
        });
        if (!n.ok) throw new Error("Cart check failed");
        var i = await n.json();
        return (i.items || []).find(function(t) {
          return t.properties && t.properties["_Personalization Submission"] === e
        })
      } finally {
        clearTimeout(r)
      }
    }
    async function ze(e) {
      if (D || z || x || !ne(e)) return;
      var readinessError = cartReadiness(e);
      if (readinessError) {
        lastValidationTarget = null;
        de(readinessError, true);
        return;
      }
      fe();
      pe();
      var t = oe(e),
        r = Ae(t);
      if (r) {
        de(r);
        return
      }
      if (!e.reportValidity()) return;
      if (j && !ue(t)) ve();
      var n = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(36) + "-" + Math.random().toString(36).slice(2);
      var i = Se(t, n);
      var o = new FormData(e);
      var s = o.get("quantity");
      var l = s == null || s === "" ? 1 : Number(s);
      if (!Number.isSafeInteger(l) || l < 1) {
        de("Please enter a valid quantity.");
        return
      }
      o.set("id", t.variant);
      o.set("quantity", String(l));
      Le(o, i);
      o.delete("sections");
      o.delete("sections_url");
      if (q) {
        N++;
        if (T) T.abort();
        clearTimeout(M);
        M = null;
        T = null;
        me(false)
      }
      Ue(true);
      var u = new AbortController,
        c = false;
      var f = setTimeout(function() {
        u.abort()
      }, 6e4);
      try {
        var d = await fetch(a("cart/add.js"), {
          method: "POST",
          body: o,
          headers: {
            Accept: "application/json"
          },
          signal: u.signal
        });
        c = !d.ok && d.status >= 400 && d.status < 500;
        var p = await d.json().catch(function() {
          return null;
        });
        if (!d.ok) {
          throw new Error(p && typeof p.description === "string" ? p.description : "Could not add this item to your cart.")
        }
        if (!p) throw new Error("The cart returned an unreadable response.");
        var h = p.items ? p.items.find(function(e) {
          return e.properties && e.properties["_Personalization Submission"] === n
        }) : p;
        if (!xe(h, i, t, l)) {
          h = await De(n);
          if (!xe(h, i, t, l)) throw new Error("Personalization details could not be verified.")
        }
        openConfirmedCart()
      } catch (e) {
        var cartChecked = false;
        var recoveredItem = null;
        try {
          recoveredItem = await De(n);
          cartChecked = true;
          if (xe(recoveredItem, i, t, l)) {
            openConfirmedCart();
            return
          }
        } catch (_) {}
        if (recoveredItem) {
          z = true;
          Ue(false);
          de("An item from this attempt is already in your cart, but its quantity or personalization could not be fully confirmed. Check your cart before checkout. Remove any incorrect item, then refresh this page before trying again.", true, true);
          return
        }
        if (c && cartChecked) {
          Ue(false);
          de(e.message, true);
          return
        }
        z = true;
        Ue(false);
        de("We could not confirm that all your details were saved. Check your cart before checkout. If this item is present with missing details, remove it, then return to this page and refresh before trying again.", true, true)
      } finally {
        clearTimeout(f)
      }
    }

    function qe(e) {
      W = {
        form: e,
        signature: se(oe(e))
      };
      var t = !q && ue(oe(e)) && O;
      o("[data-y-confirm-title]").textContent = q ? "Your preview is still being created" : "Use this AI preview?";
      o("[data-y-confirm-copy]").textContent = q ? "You can wait, or continue without the AI preview. Your selected text and/or photo will still be saved." : "Use this preview, or continue with your selected personalization details only. Your entered details will still be saved.";
      o("[data-y-confirm-approve]").hidden = !t;
      C.hidden = false;
      C.focus({
        preventScroll: true
      });
      C.scrollIntoView({
        block: "nearest",
        behavior: "auto"
      })
    }

    function Ne(e) {
      if (D || x) return;
      if (z) {
        de("Please check your cart before trying again. Remove any incomplete item, then refresh this page.", true, true);
        return
      }
      var readinessError = cartReadiness(e);
      if (readinessError) {
        lastValidationTarget = null;
        de(readinessError, true);
        return;
      }
      var t = oe(e),
        r = Ae(t);
      if (r) {
        de(r);
        return
      }
      if (!e.reportValidity()) return;
      if (j && !ue(t)) ve();
      if (q || ue(t) && !R) {
        qe(e);
        return
      }
      ze(e)
    }

    function Te(e) {
      if (!W) return;
      var t = W;
      if (!t.form.isConnected || t.signature !== se(oe(t.form))) {
        pe();
        de("Your details changed. Please review them and add the item again.");
        return
      }
      if (e && !ke()) {
        de("Please wait for the image to load before approving it.");
        return
      }
      if (!e) {
        ve()
      }
      ze(t.form)
    }

    function _e() {
      var t = i(e.dataset.yaiHelpUrl || "");
      if (t) {
        window.open(t, "_blank", "noopener,noreferrer");
        return
      }

      function r() {
        var e = ["#shopify-chat button", '#shopify-chat [role="button"]', "#shopify-chat", "shopify-chat", '[id^="shopify-chat"]', '[class*="shopify-chat"] button', '[class*="ShopifyChat"] button', 'button[aria-label*="chat" i]', '[class*="chat-launcher"]', '[data-testid*="chat" i]'];
        for (var t = 0; t < e.length; t++) {
          var r = document.querySelector(e[t]);
          if (r) {
            r.click();
            return true
          }
        }
        return false
      }
      if (!r()) setTimeout(function() {
        if (!r()) location.assign(a("pages/contact"))
      }, 400)
    }

    function Me(event) {
      var target = event.target;
      if (target.matches && target.matches("[data-y-mode]") && e.contains(target)) {
        if (!target.checked || D || target.value === activeMode) return;
        if (!Object.prototype.hasOwnProperty.call(modeLabels, target.value)) return;
        notesDrafts[activeMode] = f.value;
        activeMode = target.value;
        f.value = notesDrafts[activeMode] || "";
        editorValues.set(f, f.value);
        ve();
        fe();
        Ie();
        modeAnnouncement.textContent = activeMode === "none" ? "Original design selected. No added text, photo or preview will be included." : modeLabels[activeMode] + " selected. Only the details shown below will be included.";
        return
      }
      if (u.contains(target) && target.matches("input, textarea")) {
        if (target.disabled || D) return;
        if (target === c) {
          if (event.type !== "change") return
        } else {
          if (editorValues.has(target) && editorValues.get(target) === target.value) return;
          editorValues.set(target, target.value)
        }
        if (q || j || W) ve();
        fe();
        if (target === c) ge();
        Ce();
        return
      }
      if (target.matches && (target.matches(X) || target.name === "id" && ne(target.form))) {
        ve();
        syncOrderProperties()
      }
    }
    ee(s, "input", Me);
    ee(s, "change", Me);
    ee(w, "load", function() {
      if (!j || w.src !== j.imageUrl) return;
      O = true;
      g.disabled = D;
      if (W) qe(W.form)
    });
    ee(w, "error", function() {
      if (!j) return;
      O = false;
      R = false;
      g.disabled = true;
      A.classList.remove("show");
      Ce();
      de("The preview image could not load. Regenerate it, or add your details without approving a preview.", true);
      if (W) qe(W.form)
    });
    if (removePhoto) ee(removePhoto, "click", function() {
      if (D) return;
      c.value = "";
      ve();
      fe();
      ge();
      Ce();
      c.focus({
        preventScroll: true
      })
    });
    ee(v, "click", Ee);
    ee(y, "click", Ee);
    ee(g, "click", function() {
      if (ke()) pe()
    });
    ee(b, "click", ve);
    ee(S, "click", _e);
    ee(o("[data-y-confirm-approve]"), "click", function() {
      Te(true)
    });
    ee(o("[data-y-confirm-without]"), "click", function() {
      Te(false)
    });
    ee(o("[data-y-confirm-back]"), "click", function() {
      pe();
      v.focus()
    });
    o("[data-y-check-cart]").href = a("cart");
    var je = new MutationObserver(function(t) {
      if (!e.isConnected) {
        Re();
        return
      }
      var r = t.some(function(e) {
        if (e.type === "attributes") return e.target.name === "id";
        return Array.from(e.addedNodes).concat(Array.from(e.removedNodes)).some(function(e) {
          return e.nodeType === 1 && (e.matches('form, input[name="id"], .shopify-payment-button, [data-shopify="payment-button"], shopify-accelerated-checkout') || e.querySelector('form, input[name="id"], .shopify-payment-button, [data-shopify="payment-button"], shopify-accelerated-checkout'))
        })
      });
      if (r) {
        bindingsDirty = true;
        if ((q || j || W) && (!j || !ue(oe()))) ve();
        Ce()
      }
    });
    je.observe(s, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["value"]
    });

    function Re() {
      if (x) return;
      x = true;
      photoCheckVersion++;
      pendingPhotoFile = validatedPhotoFile = null;
      cancelAnimationFrame(orderSyncFrame);
      orderSyncFrame = 0;
      je.disconnect();
      if (D) Ue(false);
      ve();
      if (F) URL.revokeObjectURL(F);
      $.forEach(function(e) {
        e()
      });
      V.forEach(function(e) {
        e.cleanup()
      });
      V.clear();
      K.forEach(function(e) {
        if (e[1] === null) e[0].removeAttribute("form");
        else e[0].setAttribute("form", e[1])
      });
      H.forEach(function(e, t) {
        t.removeAttribute("data-y-checkout-blocked");
        t.hidden = e.hidden;
        t.toggleAttribute("inert", e.inert);
        if (e.display) t.style.setProperty("display", e.display, e.priority);
        else t.style.removeProperty("display")
      });
      t.delete(e);
      e.removeAttribute("data-y-initialized")
    }
    t.set(e, {
      owns: ne,
      sync: function() {
        bindingsDirty = true;
        syncOrderProperties()
      },
      enabled: function() {
        return activeMode !== "none" || D || z
      },
      requestAdd: Ne,
      resume: function() {
        if (D) Ue(false);
        if (q || (j && !ue(oe()))) ve();
        Ie();
        var file = c.files && c.files[0] || null;
        if (file !== validatedPhotoFile) ge();
      },
      destroy: Re
    });
    e.setAttribute("data-y-initialized", "true");
    modeInputs.forEach(function(input) {
      input.checked = input.value === "none";
      input.disabled = false
    });
    Ie();
    ge()
  }
  window[e] = {
    init: s
  };
  if (!customElements.get("yatskia-personalization")) customElements.define("yatskia-personalization", class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) s(this)
      })
    }
    disconnectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected) {
          var instance = t.get(this);
          if (instance) instance.destroy()
        }
      })
    }
  });
  document.addEventListener("submit", function(e) {
    var t = l(e.target);
    if (!t) return;
    t.sync();
    if (!t.enabled()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    t.requestAdd(e.target)
  }, true);
  document.addEventListener("click", function(e) {
    var t = e.target instanceof Element ? e.target : e.target.parentElement;
    var r = t && t.closest('button[name="add"], .product-form__submit, button[type="submit"], input[type="submit"]');
    var n = o(r),
      a = l(n);
    if (!a || !r || r.disabled || r.getAttribute("aria-disabled") === "true") return;
    a.sync();
    if (!a.enabled()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    a.requestAdd(n)
  }, true);
  document.addEventListener("shopify:section:load", function(e) {
    s(e.target)
  });
  document.addEventListener("shopify:section:unload", function(e) {
    t.forEach(function(t, r) {
      if (e.target.contains(r)) t.destroy()
    })
  });
  window.addEventListener("pageshow", function(e) {
    if (e.persisted) {
      s(document);
      t.forEach(function(instance) {
        instance.resume()
      })
    }
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function() {
    s(document)
  }, {
    once: true
  });
  else s(document)
})();
(function() {
  if (window.__yatskiaInfoPolicy) return;
  window.__yatskiaInfoPolicy = true;
  document.addEventListener("click", function(e) {
    var b = e.target.closest && e.target.closest(".y-personalization-note [data-y-info-toggle]");
    if (!b) return;
    var n = b.closest(".y-personalization-note"),
      k = b.dataset.yInfoToggle,
      open = b.getAttribute("aria-expanded") !== "true";
    n.querySelectorAll("[data-y-info-toggle]").forEach(function(t) {
      t.setAttribute("aria-expanded", String(open && t === b))
    });
    n.querySelectorAll("[data-y-info-panel]").forEach(function(p) {
      p.hidden = !(open && p.dataset.yInfoPanel === k)
    })
  })
})();

(() => {
  const tag = 'yatskia-inline-offers';
  if (customElements.get(tag)) return;
  class YatskiaQuantityOffers extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.timers = new Map();
      this.details = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      const options = {
        signal: this.controller.signal
      };
      this.addEventListener('click', event => {
        const button = event.target.closest('.yqo-copy');
        if (button && this.contains(button)) this.copyCode(button);
        if (event.target.closest('.yqo-close')) this.close(true);
      }, options);
      document.addEventListener('pointerdown', event => {
        if (this.details.open && !this.contains(event.target)) this.close(false);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          this.close(true);
        }
      }, options);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close(false);
      }, options);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.placeWithQuantity(), {
          once: true,
          signal: this.controller.signal
        });
      } else {
        queueMicrotask(() => this.placeWithQuantity());
      }
    }

    placeWithQuantity() {
      if (!this.isConnected) return;
      const product = this.closest('product-info');
      if (!product) return;
      const id = 'Quantity-Form-' + this.dataset.section;
      const quantity = Array.from(product.querySelectorAll('.product-form__quantity')).find(node => node.id === id);
      if (!quantity) return;
      const existing = quantity.querySelector(tag);
      if (existing && existing !== this) return;
      this.quantity = quantity;
      quantity.classList.add('yqo-inline-row');
      // Move only the offers. Keep the original quantity input and native listeners.
      if (this.parentElement !== quantity) quantity.append(this);
    }

    close(restoreFocus) {
      this.details.open = false;
      if (restoreFocus) this.trigger.focus({
        preventScroll: true
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.timers?.forEach(timer => clearTimeout(timer));
      if (this.details) this.details.open = false;
      this.querySelectorAll('.yqo-copy').forEach(button => {
        button.removeAttribute('data-copied');
        button.removeAttribute('aria-busy');
      });
      queueMicrotask(() => {
        if (!this.isConnected && this.quantity?.isConnected && !this.quantity.querySelector(tag)) {
          this.quantity.classList.remove('yqo-inline-row');
        }
      });
    }

    fallbackCopy(code) {
      const active = document.activeElement;
      const field = document.createElement('textarea');
      field.value = code;
      field.readOnly = true;
      field.setAttribute('aria-label', 'Discount code');
      field.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;opacity:0;font-size:16px;';
      this.append(field);
      let copied = false;
      try {
        field.focus({
          preventScroll: true
        });
        field.select();
        field.setSelectionRange(0, code.length);
        copied = document.execCommand('copy');
      } catch (_) {
        copied = false;
      } finally {
        field.remove();
        active?.focus({
          preventScroll: true
        });
      }
      return copied;
    }

    async copyCode(button) {
      if (button.getAttribute('aria-busy') === 'true') return;
      const code = button.dataset.code;
      if (!code) return;
      const signal = this.controller.signal;
      const status = this.querySelector('.yqo-status');
      button.setAttribute('aria-busy', 'true');
      let copied = false;
      try {
        if (window.isSecureContext && navigator.clipboard?.writeText) {
          try {
            await navigator.clipboard.writeText(code);
            copied = true;
          } catch (_) {
            if (!signal.aborted) copied = this.fallbackCopy(code);
          }
        } else {
          copied = this.fallbackCopy(code);
        }
        if (signal.aborted) return;
        clearTimeout(this.timers.get(button));
        button.toggleAttribute('data-copied', copied);
        status.toggleAttribute('data-error', !copied);
        status.textContent = copied ?
          code + ' copied. Paste it at checkout.' :
          'Copy unavailable. Enter ' + code + ' at checkout.';
        if (copied) this.timers.set(button, setTimeout(() => {
          button.removeAttribute('data-copied');
          this.timers.delete(button);
        }, 2400));
      } finally {
        if (!signal.aborted) button.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define(tag, YatskiaQuantityOffers);
})();

(() => {
  const tag = 'yatskia-product-controls';
  if (customElements.get(tag)) return;
  class YatskiaProductControls extends HTMLElement {
    connectedCallback() {
      if (this.lifecycle) return;
      this.lifecycle = new AbortController();
      this.mobile = matchMedia('(max-width: 749px)');
      this.mobile.addEventListener('change', () => this.refreshViewport(), {
        signal: this.lifecycle.signal
      });
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.refreshViewport(), {
          once: true,
          signal: this.lifecycle.signal
        });
      } else queueMicrotask(() => this.refreshViewport());
    }

    refreshViewport() {
      if (!this.isConnected) return;
      if (this.mobile.matches) this.mount();
      else this.unmount();
    }

    mount() {
      if (this.bar) return;
      this.product = this.closest('product-info');
      const template = this.querySelector('template');
      if (!this.product || !template || this.product.id !== 'MainProduct-' + this.dataset.section) return;
      if (Array.from(this.product.querySelectorAll(tag)).some(node => node !== this && node.bar)) return;
      this.abort = new AbortController();
      this.bar = template.content.firstElementChild.cloneNode(true);
      this.spacer = document.createElement('div');
      this.spacer.className = 'ymp-cart-spacer';
      this.spacer.setAttribute('aria-hidden', 'true');
      this.spacer.hidden = true;
      document.body.append(this.bar, this.spacer);
      this.button = this.bar.querySelector('button');
      this.caption = this.bar.querySelector('.ymp-cart-label');
      this.defaultCaption = this.caption.textContent.trim();
      this.price = this.bar.querySelector('.ymp-cart-price');
      this.quantity = this.bar.querySelector('.ymp-cart-quantity');
      this.status = this.bar.querySelector('.ymp-cart-status');
      const options = {
        signal: this.abort.signal
      };
      this.button.addEventListener('click', () => this.addToCart(), options);
      this.product.addEventListener('change', () => this.schedule(), options);
      this.product.addEventListener('input', event => {
        if (event.target.name === 'quantity') this.schedule();
      }, options);
      document.addEventListener('focusin', () => this.schedule(), options);
      document.addEventListener('focusout', () => this.schedule(), options);
      window.addEventListener('pageshow', () => this.schedule(), options);
      this.overlaySelector = 'dialog, modal-dialog, product-modal, .urn-size-guide-modal, cart-drawer, menu-drawer > details, header-drawer > details, details-modal > details';
      this.overlayState = new MutationObserver(() => this.schedule());
      document.querySelectorAll(this.overlaySelector).forEach(node => this.overlayState.observe(node, {
        attributes: true,
        attributeFilter: ['open', 'class', 'hidden', 'aria-hidden']
      }));
      // Native dialogs/details also cover components inserted after this bar mounted.
      document.addEventListener('toggle', event => {
        if (event.target.matches?.('dialog, details')) this.schedule();
      }, {
        capture: true,
        signal: this.abort.signal
      });

      // Watch replacement boundaries, not every class change in the gallery.
      const selector = 'form[id^="product-form-"], [id^="price-"], .y-personalization';
      this.structure = new MutationObserver(records => {
        const replaced = records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
          node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
        ));
        if (replaced) {
          this.bindControls();
          this.schedule();
        }
      });
      this.structure.observe(this.product.querySelector('.product__info-container') || this.product, {
        childList: true,
        subtree: true
      });
      this.observer = new MutationObserver(() => this.schedule());
      if ('IntersectionObserver' in window) {
        this.visibility = new IntersectionObserver(entries => {
          const entry = entries[entries.length - 1];
          this.nativeVisible = entry.isIntersecting && entry.intersectionRatio >= .5;
          this.schedule();
        }, {
          threshold: [0, .5, 1]
        });
      }
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(() => this.measure());
        this.resize.observe(this.bar);
      }
      this.bindControls();
      this.sync();
    }

    nativeControls() {
      const form = this.product?.querySelector('form[id="product-form-' + this.dataset.section + '"]');
      return {
        form,
        button: form?.querySelector('button[name="add"], button[type="submit"]')
      };
    }

    bindControls() {
      this.observer.disconnect();
      const {
        form,
        button
      } = this.nativeControls();
      if (form) this.observer.observe(form.closest('product-form') || form, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class', 'hidden', 'value']
      });
      this.priceBox = this.product.querySelector('[id="price-' + this.dataset.section + '"]');
      if (this.priceBox) this.observer.observe(this.priceBox, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['class']
      });
      const personalization = this.product.querySelector('.y-personalization');
      if (personalization) this.observer.observe(personalization, {
        attributes: true,
        attributeFilter: ['aria-busy']
      });
      if (button !== this.observedButton) {
        this.visibility?.disconnect();
        this.observedButton = button;
        this.nativeVisible = false;
        if (button) this.visibility?.observe(button);
      }
    }

    schedule() {
      if (this.frame || !this.bar) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.sync();
      });
    }

    setText(node, text) {
      if (node.textContent !== text) node.textContent = text;
    }

    sync() {
      if (!this.isConnected || !this.bar) return;
      const {
        form,
        button
      } = this.nativeControls();
      if (button !== this.observedButton) this.bindControls();
      const typing = document.activeElement?.matches('textarea, select, [contenteditable="true"], input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="hidden"])');
      const modalOpen = !!document.querySelector('dialog[open], modal-dialog[open], product-modal[open], .urn-size-guide-modal.is-open, .urn-size-guide-modal[aria-hidden="false"]:not([hidden]), cart-drawer.active, menu-drawer > details[open], header-drawer > details[open], details-modal > details[open]');
      const visible = !!form && !!button && !typing && !modalOpen && !this.nativeVisible;
      const busy = !!button && (button.classList.contains('loading') || button.getAttribute('aria-busy') === 'true' || !!this.product.querySelector('.y-personalization[aria-busy="true"]'));
      const nativeText = button?.querySelector('span:not(.loading__spinner):not(.svg-wrapper)')?.textContent.trim() || button?.textContent.trim();
      const priceRoot = this.priceBox?.querySelector('.price');
      const priceNode = this.priceBox?.querySelector(priceRoot?.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
      const priceText = priceNode?.textContent.trim() || '';
      const qty = form?.elements.namedItem('quantity')?.value || '1';
      if (this.bar.hidden === visible) this.bar.hidden = !visible;
      if (this.spacer.hidden === visible) this.spacer.hidden = !visible;
      document.documentElement.classList.toggle('ymp-cart-active', visible);
      this.button.disabled = !button || button.disabled || button.getAttribute('aria-disabled') === 'true' || busy || !!this.launching;
      this.button.setAttribute('aria-busy', String(busy));
      this.setText(this.caption, busy ? 'Adding…' : nativeText || this.defaultCaption);
      this.setText(this.price, priceText);
      this.price.hidden = !priceText;
      this.setText(this.quantity, (priceText ? 'Each · ' : '') + 'Qty ' + qty);
      const error = this.product.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message, [data-yai-error].show, [data-y-field-error]:not([hidden])');
      if (this.attempted && error?.textContent.trim()) {
        const message = error.textContent.trim();
        this.setText(this.status, message);
        if (this.lastError !== message) {
          this.lastError = message;
          error.closest('.product-form__error-message-wrapper')?.scrollIntoView({
            block: 'center',
            behavior: 'auto'
          });
        }
      } else if (!busy) this.setText(this.status, '');
      if (visible && !this.resize) this.measure();
    }

    measure() {
      if (!this.bar || this.bar.hidden) return;
      const height = Math.ceil(this.bar.getBoundingClientRect().height);
      if (height && height !== this.height) {
        this.height = height;
        document.documentElement.style.setProperty('--ymp-cart-height', height + 'px');
      }
    }

    addToCart() {
      const {
        form,
        button
      } = this.nativeControls();
      if (!form || !button || this.launching || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      if (!form.reportValidity()) return;
      this.attempted = true;
      this.lastError = '';
      this.setText(this.status, '');
      this.launching = true;
      this.button.disabled = true;
      button.click();
      this.sync();
      this.release = setTimeout(() => {
        this.launching = false;
        this.schedule();
      }, 400);
    }

    unmount() {
      this.abort?.abort();
      this.abort = null;
      this.structure?.disconnect();
      this.overlayState?.disconnect();
      this.observer?.disconnect();
      this.visibility?.disconnect();
      this.resize?.disconnect();
      this.resize = null;
      cancelAnimationFrame(this.frame);
      this.frame = null;
      clearTimeout(this.release);
      this.launching = false;
      this.observedButton = null;
      this.height = 0;
      this.bar?.remove();
      this.spacer?.remove();
      this.bar = null;
      if (!document.querySelector('.ymp-cart')) {
        document.documentElement.classList.remove('ymp-cart-active');
        document.documentElement.style.removeProperty('--ymp-cart-height');
      }
    }

    disconnectedCallback() {
      this.lifecycle?.abort();
      this.lifecycle = null;
      this.unmount();
    }
  }
  customElements.define(tag, YatskiaProductControls);
})();

(() => {
  const tag = 'yatskia-variant-ui';
  if (customElements.get(tag)) return;

  // Shopify replaces variant-selects after every selection. This element
  // reconnects with each replacement and cleans up the old listeners.
  class YatskiaVariantUI extends HTMLElement {
    static positions = new WeakMap();

    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.frames = new Set();
      this.owner = this.closest('product-info') || this.parentElement;
      if (!YatskiaVariantUI.positions.has(this.owner)) {
        YatskiaVariantUI.positions.set(this.owner, new Map());
      }
      this.saved = YatskiaVariantUI.positions.get(this.owner);
      this.carousels = [];
      this.querySelectorAll('.yvp-design-card__image').forEach(image => {
        image.sizes = '(max-width: 749px) 72px, 84px';
        image.decoding = 'async';
        image.draggable = false;
      });

      this.querySelectorAll('[data-yvp-size-carousel]').forEach(carousel => {
        const track = carousel.querySelector('[data-yvp-size-track]');
        const navigation = carousel.querySelector('[data-yvp-size-navigation]');
        const count = carousel.querySelector('[data-yvp-size-count]');
        const previous = carousel.querySelector('[data-yvp-size-previous]');
        const next = carousel.querySelector('[data-yvp-size-next]');
        if (!track || !navigation || !count || !previous || !next) return;

        const group = carousel.closest('[data-yvp-group]');
        const key = group.querySelector('input, select')?.name || track.id;
        const state = {
          track,
          navigation,
          count,
          previous,
          next,
          key,
          cards: Array.from(track.querySelectorAll('.yvp-size-card, .yvp-design-card'))
        };
        this.carousels.push(state);
        previous.addEventListener('click', () => this.step(state, -1), {
          signal: this.abort.signal
        });
        next.addEventListener('click', () => this.step(state, 1), {
          signal: this.abort.signal
        });
        track.addEventListener('scroll', () => {
          if (!track.clientWidth) return;
          this.saved.set(key, track.scrollLeft);
          if (state.frame) return;
          state.frame = this.queue(() => {
            state.frame = null;
            this.update(state);
          });
        }, {
          passive: true,
          signal: this.abort.signal
        });
        track.addEventListener('focusin', event => {
          if (event.target.matches('.yvp-input')) this.reveal(state, event.target);
        }, {
          signal: this.abort.signal
        });

        this.update(state);
        this.queue(() => {
          track.scrollLeft = this.saved.get(key) || 0;
          this.reveal(state, track.querySelector('input:checked'));
          this.update(state);
        });
      });

      this.addEventListener('change', event => {
        this.updateSelected();
        this.carousels.forEach(state => {
          if (state.track.contains(event.target)) this.reveal(state, event.target);
          this.saved.set(state.key, state.track.scrollLeft);
        });
      }, {
        signal: this.abort.signal
      });
      this.updateSelected();

      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(() => this.carousels.forEach(state => this.update(state, true)));
        this.carousels.forEach(state => this.resize.observe(state.track));
      } else {
        window.addEventListener('resize', () => this.carousels.forEach(state => this.update(state, true)), {
          signal: this.abort.signal
        });
      }
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.resize?.disconnect();
      this.frames?.forEach(frame => cancelAnimationFrame(frame));
    }

    queue(callback) {
      const frame = requestAnimationFrame(() => {
        this.frames.delete(frame);
        if (this.isConnected && this.abort) callback();
      });
      this.frames.add(frame);
      return frame;
    }

    updateSelected() {
      this.querySelectorAll('[data-yvp-group]').forEach(group => {
        const output = group.querySelector('[data-yvp-selected-value]');
        const input = group.querySelector('input[type="radio"]:checked');
        const select = group.querySelector('select');
        const value = input?.value || select?.selectedOptions[0]?.textContent || '';
        if (output && output.textContent.trim() !== value.trim()) output.textContent = value;
      });
    }

    reveal(state, input) {
      const card = input?.nextElementSibling;
      if (!card?.matches('.yvp-size-card, .yvp-design-card') || !state.track.clientWidth) return;
      const trackBox = state.track.getBoundingClientRect();
      const box = card.getBoundingClientRect();
      if (box.left < trackBox.left + 3) state.track.scrollLeft -= trackBox.left + 3 - box.left;
      else if (box.right > trackBox.right - 3) state.track.scrollLeft += box.right - trackBox.right + 3;
      this.saved.set(state.key, state.track.scrollLeft);
      this.update(state);
    }

    update(state, positionInputs = false) {
      const {
        track,
        navigation,
        count,
        previous,
        next,
        cards
      } = state;
      const width = track.clientWidth;
      if (!width) return;
      const scroll = track.scrollLeft;
      const needsMeasure = positionInputs || state.width !== width || !state.geometry;
      let inputs = [];
      if (needsMeasure) {
        const bounds = track.getBoundingClientRect();
        const style = getComputedStyle(track);
        const rtl = style.direction === 'rtl';
        state.geometry = cards.map(card => {
          const box = card.getBoundingClientRect();
          return {
            left: box.left - bounds.left + scroll,
            right: box.right - bounds.left + scroll,
            width: box.width
          };
        });
        inputs = cards.map(card => ({
          node: card.previousElementSibling,
          left: `${card.offsetLeft + (rtl ? card.offsetWidth - 2 : 2)}px`,
          top: `${card.offsetTop + 2}px`
        }));
        state.maxScroll = Math.max(0, track.scrollWidth - width);
        state.rtl = rtl;
        state.step = (state.geometry[0]?.width || width) + (parseFloat(style.columnGap) || 0);
        state.width = width;
      }
      const max = state.maxScroll;
      const position = Math.abs(scroll);
      const visible = state.geometry.map((box, index) => ({
          box,
          index
        }))
        .filter(({
          box
        }) => Math.min(box.right, scroll + width) - Math.max(box.left, scroll) >= box.width / 2);
      if (navigation.hidden !== (max < 2)) navigation.hidden = max < 2;
      if (previous.disabled !== (position <= 2)) previous.disabled = position <= 2;
      if (next.disabled !== (position >= max - 2)) next.disabled = position >= max - 2;
      if (visible.length) {
        const first = visible[0].index + 1;
        const last = visible[visible.length - 1].index + 1;
        const text = (first === last ? first : `${first}–${last}`) + ` of ${cards.length} options`;
        if (count.textContent !== text) count.textContent = text;
      }
      inputs.forEach(({
        node,
        left,
        top
      }) => {
        if (!node?.matches('.yvp-input')) return;
        if (node.style.left !== left) node.style.left = left;
        if (node.style.top !== top) node.style.top = top;
      });
    }

    step(state, direction) {
      this.update(state);
      const step = state.step || state.track.clientWidth;
      const rtl = state.rtl;
      state.track.scrollBy({
        left: direction * step * (rtl ? -1 : 1),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      this.update(state);
    }
  }
  customElements.define(tag, YatskiaVariantUI);
})();

(() => {
  const tag = 'yatskia-details-enhancer';
  if (customElements.get(tag)) return;
  const rowSelector = '.yatskia-product-description, .yp-detail-row';
  const paths = {
    description: '<path d="M6 3h8l4 4v14H6V3Zm8 0v5h4M9 12h6M9 16h6"/>',
    shipping: '<path d="M3 6h11v11H3V6Zm11 4h4l3 4v3h-7"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>',
    returns: '<path d="m12 3 8 3v6c0 5-8 9-8 9s-8-4-8-9V6l8-3Z"/><path d="m8 12 3 3 5-6"/>',
    engraving: '<path d="m15 4 5 5M4 20l5-1L20 8a2 2 0 0 0-5-5L4 14l-1 7 1-1Z"/>'
  };
  customElements.define(tag, class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.mount(), {
          once: true,
          signal: this.abort.signal
        });
      } else queueMicrotask(() => this.mount());
    }
    mount() {
      if (!this.isConnected || this.mounted) return;
      const product = this.closest('product-info');
      const info = product?.querySelector('.product__info-container');
      if (!info || Array.from(product.querySelectorAll(tag)).some(node => node !== this && node.mounted)) return;
      this.mounted = true;
      this.groups = [];
      this.rows = [];
      this.positions = [];
      Array.from(info.children).forEach(first => {
        // Reuse a group created by the earlier mobile-cart block when present.
        if (first.parentElement !== info) return;
        if (first.matches('.ymp-accordion-group')) {
          first.classList.add('yp-details-group');
          this.groups.push({
            node: first,
            owned: false
          });
          Array.from(first.children).filter(row => row.matches(rowSelector + ', .product__accordion')).forEach(row => this.decorate(row));
          return;
        }
        if (!first.matches(rowSelector)) return;
        const group = document.createElement('div');
        // The compatibility class also prevents the older cart block from grouping these rows twice.
        group.className = 'yp-details-group ymp-accordion-group';
        first.before(group);
        this.groups.push({
          node: group,
          owned: true
        });
        let row = first;
        while (row) {
          const next = row.nextElementSibling;
          if (row.matches(rowSelector)) {
            const marker = document.createComment('product-details-position');
            row.before(marker);
            this.positions.push({
              row,
              marker
            });
            group.append(row);
            this.decorate(row, marker);
          } else if (!row.matches('style, script')) break;
          row = next;
        }
      });
    }
    decorate(row, marker = null) {
      const details = row.matches('details') ? row : row.querySelector(':scope > details');
      const summary = details?.querySelector(':scope > summary');
      if (!summary) return;
      const text = summary.textContent;
      const kind = /shipping|delivery/i.test(text) ? 'shipping' : /return|guarantee/i.test(text) ? 'returns' : /personali|engraving/i.test(text) ? 'engraving' : 'description';
      let label = summary.querySelector(':scope > .ymp-accordion-label');
      const createdLabel = !label;
      if (!label) {
        label = document.createElement('div');
        label.append(...summary.childNodes);
        summary.append(label);
      }
      label.classList.add('yp-details-label');
      let icon = summary.querySelector(':scope > .ymp-accordion-icon');
      const createdIcon = !icon;
      if (!icon) {
        icon = document.createElement('span');
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" focusable="false">' + paths[kind] + '</svg>';
        summary.prepend(icon);
      }
      icon.classList.add('yp-details-icon');
      const toggle = document.createElement('span');
      toggle.className = 'yp-details-toggle';
      toggle.setAttribute('aria-hidden', 'true');
      summary.append(toggle);
      summary.classList.add('yp-details-summary');
      row.classList.add('yp-details-row');
      const content = details.querySelector(':scope > .yatskia-product-description__content, :scope > .accordion__content');
      content?.classList.add('yp-details-content');
      this.rows.push({
        row,
        marker,
        summary,
        label,
        createdLabel,
        icon,
        createdIcon,
        toggle,
        content
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.rows?.forEach(item => {
        item.toggle.remove();
        if (item.createdIcon) item.icon.remove();
        else item.icon.classList.remove('yp-details-icon');
        if (item.createdLabel) {
          item.label.before(...item.label.childNodes);
          item.label.remove();
        } else item.label.classList.remove('yp-details-label');
        item.summary.classList.remove('yp-details-summary');
        item.row.classList.remove('yp-details-row');
        item.content?.classList.remove('yp-details-content');
      });
      this.positions?.forEach(item => item.marker.replaceWith(item.row));
      this.groups?.forEach(group => {
        if (group.owned) group.node.remove();
        else group.node.classList.remove('yp-details-group');
      });
      this.rows = [];
      this.positions = [];
      this.groups = [];
      this.mounted = false;
    }
  });
})();

(() => {
  const tag = 'yatskia-arrival-date';
  if (customElements.get(tag)) return;
  customElements.define(tag, class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.onVisibility = () => {
        clearTimeout(this.arrivalTimer);
        if (!document.hidden) this.refresh();
      };
      document.addEventListener('visibilitychange', this.onVisibility, {
        signal: this.controller.signal
      });
      window.addEventListener('pageshow', this.onVisibility, {
        signal: this.controller.signal
      });
      this.refresh();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      clearTimeout(this.arrivalTimer);
    }
    businessDate(start, days) {
      const date = new Date(start);
      date.setHours(12, 0, 0, 0);
      while (days > 0) {
        date.setDate(date.getDate() + 1);
        if (this.dataset.dayType === 'calendar' || (date.getDay() !== 0 && date.getDay() !== 6)) days--;
      }
      return date;
    }
    refresh() {
      clearTimeout(this.arrivalTimer);
      if (!this.isConnected) return;
      const output = this.querySelector('[data-y-arrival-range]');
      if (!output) return;
      const min = Math.min(30, Math.max(0, Number(this.dataset.minDays) || 0));
      const max = Math.min(30, Math.max(min, Number(this.dataset.maxDays) || 0));
      const now = new Date();
      const first = this.businessDate(now, min);
      const last = this.businessDate(now, max);
      const format = new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {
        month: 'short',
        day: 'numeric',
        ...(first.getFullYear() !== now.getFullYear() || last.getFullYear() !== now.getFullYear() ? {
          year: 'numeric'
        } : {})
      });
      const makeTime = date => {
        const time = document.createElement('time');
        time.dateTime = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        time.textContent = format.format(date);
        return time;
      };
      const key = `${now.getFullYear()}-${now.getMonth()}-${now.getDate()}:${min}:${max}:${format.resolvedOptions().locale}`;
      if (this.lastKey !== key) {
        const nodes = [makeTime(first)];
        if (max !== min) nodes.push(document.createTextNode(' – '), makeTime(last));
        output.replaceChildren(...nodes);
        this.lastKey = key;
      }
      if (!document.hidden) {
        const nextDay = new Date(now);
        nextDay.setHours(24, 0, 1, 0);
        this.arrivalTimer = setTimeout(() => this.refresh(), nextDay - now);
      }
    }
  });
})();

/* Isolated quick-add forms: never copy the main product's personalization. */
(() => {
  if (customElements.get('yatskia-product-addons')) return;

  class YatskiaProductAddons extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.events) return;
        this.track = this.querySelector('[data-ypa-track]');
        if (!this.track) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.addEventListener('submit', event => this.addProduct(event), options);
        this.addEventListener('change', event => this.changeVariant(event), options);
        this.addEventListener('click', event => {
          const arrow = event.target.closest('[data-ypa-direction]');
          if (!arrow) return;
          const item = this.track.querySelector('[data-ypa-item]');
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({
            left: (item.getBoundingClientRect().width + gap) * Number(arrow.dataset.ypaDirection) * direction,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        }, options);
        this.track.addEventListener('scroll', () => this.scheduleNavigation(), { ...options, passive: true });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.scheduleNavigation());
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', () => this.scheduleNavigation(), options);
        }
        this.scheduleNavigation();
      });
    }

    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.navigationFrame);
    }

    scheduleNavigation() {
      cancelAnimationFrame(this.navigationFrame);
      this.navigationFrame = requestAnimationFrame(() => {
        const items = this.track.querySelectorAll('[data-ypa-item]');
        const navigation = this.querySelector('[data-ypa-navigation]');
        if (!items.length || !navigation) return;
        navigation.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
        const bounds = this.track.getBoundingClientRect();
        const first = items[0].getBoundingClientRect();
        const last = items[items.length - 1].getBoundingClientRect();
        const rtl = getComputedStyle(this).direction === 'rtl';
        navigation.querySelector('[data-ypa-direction="-1"]').disabled = rtl ? first.right <= bounds.right + 3 : first.left >= bounds.left - 3;
        navigation.querySelector('[data-ypa-direction="1"]').disabled = rtl ? last.left >= bounds.left - 3 : last.right <= bounds.right + 3;
      });
    }

    changeVariant(event) {
      const select = event.target.closest('[data-ypa-variant]');
      if (!select) return;
      const form = select.closest('[data-ypa-form]');
      const option = select.selectedOptions[0];
      if (!option) return;
      form.querySelector('[data-ypa-price]').textContent = option.dataset.price;
      const compare = form.querySelector('[data-ypa-compare]');
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
      if (option.dataset.url) form.querySelectorAll('[data-ypa-product-link]').forEach(link => { link.href = option.dataset.url; });
      const image = form.querySelector('img.ypa__image');
      if (image && option.dataset.image) {
        image.removeAttribute('srcset');
        image.src = option.dataset.image;
      }
      const button = form.querySelector('[data-ypa-add]');
      button.removeAttribute('data-added');
      button.disabled = Boolean(this.pending || form.dataset.ypaUnconfirmed || option.disabled);
    }

    setBusy(busy, activeButton) {
      this.pending = busy;
      this.querySelectorAll('[data-ypa-form]').forEach(form => {
        const select = form.querySelector('[data-ypa-variant]');
        if (select) select.disabled = busy || Boolean(form.dataset.ypaUnconfirmed);
        const button = form.querySelector('[data-ypa-add]');
        if (button) button.disabled = busy || Boolean(form.dataset.ypaUnconfirmed) || Boolean(select?.selectedOptions[0]?.disabled);
      });
      if (busy) activeButton.setAttribute('aria-busy', 'true');
      else activeButton.removeAttribute('aria-busy');
    }

    updateCart(data, drawer) {
      const bubble = document.getElementById('cart-icon-bubble');
      const html = data.sections?.['cart-icon-bubble'];
      if (bubble && html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const content = parsed.getElementById('cart-icon-bubble') || parsed.getElementById('shopify-section-cart-icon-bubble');
        if (content) bubble.innerHTML = content.innerHTML;
      }
      if (drawer && typeof drawer.renderContents === 'function' && data.items?.[0]) {
        const required = drawer.getSectionsToRender?.() || [];
        if (required.every(section => data.sections?.[section.id])) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ ...data.items[0], sections: data.sections });
        }
      }
    }

    async addProduct(event) {
      const form = event.target.closest('[data-ypa-form]');
      if (!form || !form.querySelector('[data-ypa-add]')) return;
      event.preventDefault();
      event.stopPropagation();
      if (this.pending || form.dataset.ypaUnconfirmed) return;
      const variant = form.elements.namedItem('id');
      const button = form.querySelector('[data-ypa-add]');
      if (!variant?.value || button.disabled) return;
      const status = this.querySelector('[data-ypa-status]');
      const cartLink = this.querySelector('[data-ypa-cart-link]');
      const drawer = document.querySelector('cart-drawer');
      const sectionIds = ['cart-icon-bubble'];
      if (typeof drawer?.getSectionsToRender === 'function') {
        drawer.getSectionsToRender().forEach(section => {
          if (!sectionIds.includes(section.id) && sectionIds.length < 5) sectionIds.push(section.id);
        });
        drawer.setActiveElement?.(button);
      }
      this.setBusy(true, button);
      button.removeAttribute('data-added');
      status.textContent = 'Adding to cart…';
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      let confirmed = false;
      let cartErrorMessage = '';
      try {
        const response = await fetch(`${form.getAttribute('action')}.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          signal: controller.signal,
          body: JSON.stringify({
            items: [{ id: variant.value, quantity: 1 }],
            sections: sectionIds,
            sections_url: this.dataset.cartUrl
          })
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          // Some cart errors can still change quantities. Ask the customer to check first.
          cartErrorMessage = typeof data.description === 'string' ? data.description : '';
          throw new Error('Cart update rejected');
        }
        if (!data.items?.length) throw new Error('Cart response incomplete');
        confirmed = true;
        button.setAttribute('data-added', '');
        status.textContent = `${form.dataset.productTitle} added to your cart.`;
        // A section-render failure must never turn a successful add into a retry.
        try { this.updateCart(data, drawer); } catch (error) { /* View cart remains available. */ }
      } catch {
        if (!confirmed) {
          form.dataset.ypaUnconfirmed = 'true';
          const message = cartErrorMessage || 'The cart update could not be confirmed.';
          status.textContent = `${message} Check your cart before trying again. Reload this page to try again.`;
        }
      } finally {
        clearTimeout(timeout);
        cartLink.hidden = false;
        this.setBusy(false, button);
      }
    }
  }
  customElements.define('yatskia-product-addons', YatskiaProductAddons);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  (() => {
    const elementName = 'yatskia-related-products';
    if (!('customElements' in window) || customElements.get(elementName)) return;

    customElements.define(elementName, class extends HTMLElement {
      connectedCallback() {
        if (this.lifecycle && !this.lifecycle.signal.aborted) return;
        this.lifecycle = new AbortController();
        const lifecycle = this.lifecycle;
        const initialize = () => {
          if (!this.isConnected || lifecycle.signal.aborted) return;
          this.content = this.querySelector('[data-yrp-content]');
          this.errorBox = this.querySelector('[data-yrp-error]');
          this.feedbackStatus = this.querySelector('[data-yrp-feedback-status]');
          if (!this.content || !this.errorBox) return;
          // A pending retry must not reclaim focus after the customer moves away.
          const preserveNewFocus = event => {
            if (this.retryFocused && !this.contains(event.target)) this.retryFocused = false;
          };
          document.addEventListener('focusin', preserveNewFocus, { signal: lifecycle.signal });
          document.addEventListener('pointerdown', preserveNewFocus, { signal: lifecycle.signal, passive: true });
          this.querySelector('[data-yrp-retry]')?.addEventListener('click', () => {
            this.retryFocused = true;
            this.load();
          }, { signal: lifecycle.signal });
          if (this.querySelector('[data-yrp-item]')) {
            this.dataset.state = 'ready';
            this.setupSlider();
          } else if (this.dataset.performed === 'true' || !this.dataset.productId) {
            this.showEmpty();
          } else if ('IntersectionObserver' in window) {
            this.visibility = new IntersectionObserver(entries => {
              if (!entries.some(entry => entry.isIntersecting)) return;
              this.visibility.disconnect();
              this.load();
            }, { rootMargin: '400px 0px' });
            this.visibility.observe(this);
          } else {
            this.load();
          }
        };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', initialize, { once: true, signal: lifecycle.signal });
        } else queueMicrotask(initialize);
      }

      disconnectedCallback() {
        this.lifecycle?.abort();
        this.request?.abort();
        this.visibility?.disconnect();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
        clearTimeout(this.fetchTimer);
        clearTimeout(this.announceTimer);
        this.slider = null;
        this.retryFocused = false;
        this.removeAttribute('aria-busy');
        this.removeAttribute('data-enhanced');
        if (this.dataset.state === 'loading') this.dataset.state = 'idle';
      }

      async load() {
        if (this.dataset.state === 'loading' || !this.isConnected || !this.content || this.lifecycle?.signal.aborted) return;
        const lifecycle = this.lifecycle;
        this.dataset.state = 'loading';
        this.hidden = false;
        this.setAttribute('aria-busy', 'true');
        this.errorBox.hidden = true;
        this.setFeedback('');
        const editorNotice = this.querySelector('[data-yrp-empty]');
        if (editorNotice) editorNotice.hidden = true;
        const skeleton = this.querySelector('[data-yrp-loading]');
        if (skeleton) this.content.replaceChildren(skeleton.content.cloneNode(true));
        this.request = new AbortController();
        const request = this.request;
        const fetchTimer = setTimeout(() => request.abort(), 12000);
        this.fetchTimer = fetchTimer;
        try {
          const url = new URL(this.dataset.url, location.origin);
          if (url.origin !== location.origin) throw new Error('Invalid recommendation URL');
          url.searchParams.set('product_id', this.dataset.productId);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { signal: request.signal, headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Recommendation request failed');
          const text = await response.text();
          if (!this.isConnected || lifecycle.signal.aborted || this.request !== request) return;
          if (request.signal.aborted) throw new Error('Recommendation request timed out');
          const html = new DOMParser().parseFromString(text, 'text/html');
          const source = Array.from(html.querySelectorAll(elementName)).find(node => node.dataset.sectionId === this.dataset.sectionId);
          if (!source || source.dataset.performed !== 'true') throw new Error('Missing recommendation section');
          const result = source.querySelector('[data-yrp-content]');
          if (!result) throw new Error('Missing recommendation content');
          this.content.replaceChildren(...Array.from(result.childNodes, node => document.importNode(node, true)));
          this.dataset.performed = 'true';
          if (!this.querySelector('[data-yrp-item]')) {
            this.showEmpty();
          } else {
            this.dataset.state = 'ready';
            this.setupSlider();
            if (this.retryFocused && this.slider) this.slider.focus({ preventScroll: true });
          }
        } catch (error) {
          if (!this.isConnected || lifecycle.signal.aborted || this.request !== request) return;
          this.content.replaceChildren();
          this.dataset.state = 'error';
          this.errorBox.hidden = false;
          this.setFeedback('More designs could not load. Use Try again to retry.');
          if (this.retryFocused) this.querySelector('[data-yrp-retry]').focus({ preventScroll: true });
        } finally {
          clearTimeout(fetchTimer);
          if (!lifecycle.signal.aborted && this.request === request) {
            this.fetchTimer = null;
            this.request = null;
            this.removeAttribute('aria-busy');
            this.retryFocused = false;
          }
        }
      }

      setFeedback(message) {
        if (this.feedbackStatus && this.feedbackStatus.textContent !== message) this.feedbackStatus.textContent = message;
      }

      showEmpty() {
        this.dataset.state = 'empty';
        this.content?.replaceChildren();
        const editorNotice = this.querySelector('[data-yrp-empty]');
        if (editorNotice) editorNotice.hidden = false;
        else this.hidden = true;
      }

      setupSlider() {
        const slider = this.querySelector('[data-yrp-list]');
        if (!slider || slider === this.slider) return;
        this.resize?.disconnect();
        this.sliderEvents?.abort();
        clearTimeout(this.announceTimer);
        this.slider = slider;
        this.items = Array.from(slider.querySelectorAll('[data-yrp-item]'));
        if (!this.items.length) return;
        this.previous = this.querySelector('[data-yrp-previous]');
        this.next = this.querySelector('[data-yrp-next]');
        this.footer = this.querySelector('[data-yrp-footer]');
        this.range = this.querySelector('[data-yrp-range]');
        this.progress = this.querySelector('[data-yrp-progress]');
        this.status = this.querySelector('[data-yrp-status]');
        this.setAttribute('data-enhanced', '');
        this.sliderEvents = new AbortController();
        const sliderEvents = this.sliderEvents;
        this.lifecycle.signal.addEventListener('abort', () => sliderEvents.abort(), { once: true });
        const options = { signal: sliderEvents.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        slider.addEventListener('scroll', () => {
          this.scheduleUpdate();
          clearTimeout(this.announceTimer);
          this.announceTimer = setTimeout(() => this.announce(), 180);
        }, { ...options, passive: true });
        slider.addEventListener('keydown', event => {
          if (event.target !== slider || event.altKey || event.ctrlKey || event.metaKey) return;
          const rtl = getComputedStyle(slider).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.scrollToPosition(event.key === 'Home' ? 0 : this.maximum());
          }
        }, options);
        slider.addEventListener('focusin', event => {
          const item = event.target.closest('[data-yrp-item]');
          if (!item) return;
          const box = item.getBoundingClientRect();
          const viewport = slider.getBoundingClientRect();
          if (box.left < viewport.left || box.right > viewport.right) {
            const rtl = getComputedStyle(slider).direction === 'rtl';
            const delta = rtl ? viewport.right - box.right : box.left - viewport.left;
            this.scrollToPosition(this.position() + delta);
          }
        }, options);
        if ('ResizeObserver' in window) {
          this.resize = new ResizeObserver(() => this.scheduleUpdate());
          this.resize.observe(slider);
          this.resize.observe(this.items[0]);
        } else window.addEventListener('resize', () => this.scheduleUpdate(), options);
        this.update();
      }

      maximum() { return Math.max(0, this.slider.scrollWidth - this.slider.clientWidth); }
      position(maximum = this.maximum(), rtl = getComputedStyle(this.slider).direction === 'rtl') {
        // Preserve the sign before clamping Safari's bounce beyond either edge.
        const position = this.slider.scrollLeft * (rtl ? -1 : 1);
        return Math.min(maximum, Math.max(0, position));
      }
      scrollToPosition(position) {
        const rtl = getComputedStyle(this.slider).direction === 'rtl';
        const target = Math.max(0, Math.min(this.maximum(), position));
        this.slider.scrollTo({
          left: target * (rtl ? -1 : 1),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
      move(direction) {
        const gap = parseFloat(getComputedStyle(this.slider).columnGap) || 0;
        this.scrollToPosition(this.position() + direction * (this.items[0].getBoundingClientRect().width + gap));
      }
      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      }
      update() {
        if (!this.slider || !this.isConnected || !this.items.length) return;
        // Read layout before changing controls to avoid interleaving reads/writes.
        const width = this.slider.clientWidth;
        const scrollWidth = this.slider.scrollWidth;
        const maximum = Math.max(0, scrollWidth - width);
        const rtl = getComputedStyle(this.slider).direction === 'rtl';
        const position = this.position(maximum, rtl);
        const viewport = this.slider.getBoundingClientRect();
        const visible = [];
        let closest = 1;
        let largestOverlap = 0;
        this.items.forEach((item, index) => {
          const box = item.getBoundingClientRect();
          if (box.width <= 0) return;
          const overlap = Math.max(0, Math.min(box.right, viewport.right) - Math.max(box.left, viewport.left));
          if (overlap >= box.width * .75) visible.push(index + 1);
          if (overlap > largestOverlap) {
            largestOverlap = overlap;
            closest = index + 1;
          }
        });
        // Between snap points neither card may meet the 75% visibility threshold.
        const start = visible[0] || closest;
        const end = visible[visible.length - 1] || start;
        const label = (start === end ? start : `${start}–${end}`) + ` / ${this.items.length}`;
        const fraction = maximum <= 2 ? 1 : (position + width) / scrollWidth;
        const progress = String(Math.min(1, fraction));
        const hidden = maximum <= 2;
        const atStart = position <= 2;
        const atEnd = position >= maximum - 2;
        const focused = document.activeElement;
        const restoreFocus = (hidden && this.footer.contains(focused)) ||
          (atStart && focused === this.previous) || (atEnd && focused === this.next);
        if (this.footer.hidden !== hidden) this.footer.hidden = hidden;
        if (this.previous.disabled !== atStart) this.previous.disabled = atStart;
        if (this.next.disabled !== atEnd) this.next.disabled = atEnd;
        this.toggleAttribute('data-rtl', rtl);
        if (this.range.textContent !== label) this.range.textContent = label;
        this.visibleRange = `Products ${start === end ? start : `${start} to ${end}`} of ${this.items.length}`;
        if (this.progress.style.getPropertyValue('--yrp-progress') !== progress) this.progress.style.setProperty('--yrp-progress', progress);
        // Keep keyboard navigation available when its focused arrow disappears or disables.
        if (restoreFocus) this.slider.focus({ preventScroll: true });
      }
      announce() {
        if (this.contains(document.activeElement) && this.status && this.visibleRange && this.status.textContent !== this.visibleRange) {
          this.status.textContent = this.visibleRange;
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yatskia-slide-segments')) {
    customElements.define('yatskia-slide-segments', class extends HTMLElement {
      connectedCallback() {
        const connection = this.connection = {};
        customElements.whenDefined('slideshow-component').then(() => {
          if (this.isConnected && this.connection === connection) this.setup();
        });
      }

      setup() {
        this.slideshow = this.closest('slideshow-component');
        this.slider = this.slideshow?.querySelector('.slideshow');
        this.slides = this.slider ? [...this.slider.querySelectorAll('.slideshow__slide')] : [];
        this.buttons = [...this.querySelectorAll('[data-cue-index]')];
        this.fills = [...this.querySelectorAll('[data-cue-fill]')];
        if (this.slides.length < 2 || this.buttons.length !== this.slides.length) return;
        if (typeof this.slideshow.setSlidePosition !== 'function') return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplay = this.slider.dataset.autoplay === 'true';
        if (this.autoplay && ['play', 'pause', 'autoPlayToggle'].some(name => typeof this.slideshow[name] !== 'function')) return;
        this.duration = Math.max(1, Number(this.slider.dataset.speed) || 5) * 1000;
        this.running = false;
        this.wantsPlay = this.autoplay && this.slideshow.autoplayButtonIsSetToPlay && this.slider.getAttribute('aria-live') === 'off';
        const bounds = this.slideshow.getBoundingClientRect();
        this.inView = bounds.bottom > 0 && bounds.top < innerHeight;
        this.renderSlide();

        if (this.autoplay) {
          this.originals = {};
          this.wrappers = {};
          for (const name of ['play', 'pause']) {
            this.originals[name] = {
              fn: this.slideshow[name],
              descriptor: Object.getOwnPropertyDescriptor(this.slideshow, name)
            };
            this.wrappers[name] = (...args) => {
              this.wantsPlay = name === 'play';
              if (!this.wantsPlay || !this.canRun()) return this.stop();
              const result = this.originals.play.fn.apply(this.slideshow, args);
              this.start();
              return result;
            };
            this.slideshow[name] = this.wrappers[name];
          }
        }

        this.addEventListener('click', event => {
          const button = event.target.closest('[data-cue-index]');
          if (!button) return;
          event.preventDefault();
          const slide = this.slides[Number(button.dataset.cueIndex)];
          if (slide) this.slideshow.setSlidePosition(slide.offsetLeft - this.slides[0].offsetLeft);
        }, options);
        this.slideshow.addEventListener('slideChanged', () => {
          if (this.running) this.slideshow.play();
          else this.renderSlide();
        }, options);

        const respectMotion = () => {
          if (this.motion.matches && this.slideshow.autoplayButtonIsSetToPlay) this.slideshow.autoPlayToggle();
          if (!this.running) this.renderSlide();
        };
        this.motion.addEventListener('change', respectMotion, options);
        document.addEventListener('visibilitychange', () => this.updateVisibility(), options);
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.updateVisibility();
        });
        this.visibilityObserver.observe(this.slideshow);
        this.media = this.slides[0].querySelector('.slideshow__media');
        this.resizeObserver = new ResizeObserver(() => this.position());
        this.resizeObserver.observe(this.slider);
        if (this.media) this.resizeObserver.observe(this.media);
        this.buttons.forEach(button => { button.hidden = false; });
        this.position();
        respectMotion();
        this.updateVisibility();
      }

      canRun() { return this.inView && !document.hidden; }

      updateVisibility() {
        const visible = this.canRun();
        this.slideshow.dataset.yuVisible = String(visible);
        if (!this.autoplay) return;
        if (!visible) this.stop();
        else if (this.wantsPlay && this.slideshow.autoplayButtonIsSetToPlay && !this.running) this.slideshow.play();
      }

      stop() {
        this.running = false;
        this.animation?.pause();
        return this.originals?.pause.fn.call(this.slideshow);
      }

      renderSlide() {
        this.animation?.cancel();
        this.animation = null;
        this.current = Math.max(0, Math.min((this.slideshow.currentPage || 1) - 1, this.slides.length - 1));
        this.fill = this.fills[this.current];
        this.buttons.forEach((button, index) => {
          button.classList.toggle('is-active', index === this.current);
          if (index === this.current) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
          this.fills[index].style.transform = `scaleX(${index <= this.current ? 1 : 0})`;
        });
      }

      start() {
        this.running = true;
        this.renderSlide();
        if (this.motion.matches) return;
        this.fill.style.transform = 'scaleX(0)';
        this.animation = this.fill.animate(
          [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
          { duration: this.duration, easing: 'linear', fill: 'forwards' }
        );
      }

      // Measure only when the image/container size changes, never per animation frame.
      position() {
        cancelAnimationFrame(this.positionFrame);
        this.positionFrame = requestAnimationFrame(() => {
          if (!this.isConnected || !this.media) return;
          const outer = this.slideshow.getBoundingClientRect();
          const slider = this.slider.getBoundingClientRect();
          const image = this.media.getBoundingClientRect();
          const inset = slider.width < 750 ? 10 : 16;
          const gap = parseFloat(getComputedStyle(this).columnGap) || 8;
          this.style.width = `${Math.min(this.slides.length * 52 + (this.slides.length - 1) * gap, Math.max(0, slider.width - 24))}px`;
          this.style.bottom = 'auto';
          this.style.left = `${slider.left - outer.left + slider.width / 2}px`;
          this.style.top = `${Math.max(image.top - outer.top + 8, image.bottom - outer.top - 44 - inset)}px`;
        });
      }

      disconnectedCallback() {
        this.connection = null;
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.animation?.cancel();
        cancelAnimationFrame(this.positionFrame);
        if (!this.slideshow) return;
        if (!this.slideshow.isConnected) this.originals?.pause.fn.call(this.slideshow);
        for (const name of ['play', 'pause']) {
          if (!this.wrappers || this.slideshow[name] !== this.wrappers[name]) continue;
          const descriptor = this.originals[name].descriptor;
          if (descriptor) Object.defineProperty(this.slideshow, name, descriptor);
          else delete this.slideshow[name];
        }
        delete this.slideshow.dataset.yuVisible;
        this.slideshow = null;
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yatskia-cart-upsell"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('yatskia-cart-upsell')) return;
  let locked = false;
  function freezeCart() {
    document.querySelectorAll('cart-items, cart-drawer-items, #main-cart-footer, .additional-checkout-buttons, yatskia-cart-upsell [data-ycu-track]')
      .forEach(el => { el.inert = true; });
  }
  // Prevent checkout or another cart form submission while this add is unresolved.
  document.addEventListener('submit', event => {
    if (locked && event.target.matches('form[action*="/cart"], #cart')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  window.addEventListener('pageshow', event => {
    if (event.persisted && locked) window.location.reload();
  });

  class YatskiaCartUpsell extends HTMLElement {
    connectedCallback() {
      // Theme-editor insertion can connect the element before its children exist.
      if (!this.querySelector('[data-ycu-review]')) {
        this.mountObserver?.disconnect();
        this.mountObserver = new MutationObserver(() => {
          if (this.querySelector('[data-ycu-review]')) this.connectedCallback();
        });
        this.mountObserver.observe(this, { childList:true, subtree:true });
        return;
      }
      this.mountObserver?.disconnect();
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      const opts = { signal:this.cleanup.signal };
      this.track = this.querySelector('[data-ycu-track]');
      this.status = this.querySelector('[data-ycu-status]');
      this.error = this.querySelector('[data-ycu-error]');
      this.review = this.querySelector('[data-ycu-review]');
      if (!this.track) return;
      const cartItems = document.querySelector('cart-items');
      if (cartItems && this.dataset.showOnEmpty === 'false' && this.dataset.designMode !== 'true') {
        this.cartObserver = new MutationObserver(() => {
          this.hidden = cartItems.classList.contains('is-empty');
        });
        this.cartObserver.observe(cartItems, { attributes:true, attributeFilter:['class'] });
      }
      this.addEventListener('submit', event => this.add(event), opts);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-ycu-variant]')) this.updateVariant(event.target);
      }, opts);
      this.querySelector('[data-ycu-prev]').addEventListener('click', () => this.move(-1), opts);
      this.querySelector('[data-ycu-next]').addEventListener('click', () => this.move(1), opts);
      this.track.addEventListener('scroll', () => this.updateArrows(), { ...opts, passive:true });
      window.addEventListener('resize', () => this.updateArrows(), opts);
      document.addEventListener('shopify:block:select', event => {
        const card = [...this.querySelectorAll('[data-ycu-card]')].find(el => el.dataset.blockId === event.detail?.blockId);
        card?.scrollIntoView({ block:'nearest', inline:'nearest', behavior:'auto' });
      }, opts);
      this.querySelectorAll('[data-ycu-variant]').forEach(select => this.updateVariant(select));
      if (window.ResizeObserver) {
        this.resize = new ResizeObserver(() => this.updateArrows());
        this.resize.observe(this.track);
      }
      this.updateArrows();
    }
    disconnectedCallback() {
      this.cleanup?.abort();
      this.resize?.disconnect();
      this.cartObserver?.disconnect();
      this.mountObserver?.disconnect();
    }
    updateVariant(select) {
      const option = select.selectedOptions[0];
      if (!option) return;
      const card = select.closest('[data-ycu-card]');
      card.querySelector('[data-ycu-price]').textContent = option.dataset.price;
      const compare = card.querySelector('[data-ycu-compare]');
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
      card.querySelector('[data-ycu-add]').disabled = option.disabled;
      const img = card.querySelector('img');
      if (img && option.dataset.image && img.getAttribute('src') !== option.dataset.image) {
        img.removeAttribute('srcset');
        img.src = option.dataset.image;
      }
    }
    updateArrows() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      this.querySelector('[data-ycu-controls]').hidden = max <= 2;
      this.querySelector('[data-ycu-hint]').hidden = max <= 2;
      this.querySelector('[data-ycu-prev]').disabled = position <= 2;
      this.querySelector('[data-ycu-next]').disabled = position >= max - 2;
    }
    move(direction) {
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollBy({
        left:direction * (rtl ? -1 : 1) * this.track.clientWidth,
        behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
    async add(event) {
      const form = event.target.closest('[data-ycu-form]');
      if (!form || !this.contains(form)) return;
      event.preventDefault();
      event.stopPropagation();
      if (locked) return;
      this.error.textContent = '';
      if (this.dataset.designMode === 'true') {
        this.error.textContent = 'Open your store preview in a new tab to test Add to cart.';
        return;
      }
      if (window.YatskiaCartGuard?.blocked()) {
        window.YatskiaCartGuard.explain();
        this.error.textContent = 'Finish saving your cart changes before adding another item.';
        return;
      }
      if (document.querySelector('.cart__items--disabled')) {
        this.error.textContent = 'Please wait while your cart updates.';
        return;
      }
      const select = form.querySelector('[data-ycu-variant]');
      const id = select.value;
      if (!/^\d+$/.test(id) || select.selectedOptions[0]?.disabled) return;
      const addURL = new URL(this.dataset.addUrl, window.location.origin);
      const cartURL = new URL(this.dataset.cartUrl, window.location.origin);
      if (addURL.origin !== window.location.origin || cartURL.origin !== window.location.origin) return;
      addURL.pathname = addURL.pathname.replace(/\/$/, '') + '.js';
      if (cartURL.pathname === window.location.pathname) cartURL.search = window.location.search;
      const button = form.querySelector('[data-ycu-add]');
      const label = button.querySelector('[data-ycu-label]');
      const oldLabel = label.textContent;
      locked = true;
      freezeCart();
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      label.textContent = 'Adding…';
      this.status.textContent = 'Adding your selection…';
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      let customerMessage = '';
      try {
        const response = await fetch(addURL.href, {
          method:'POST', credentials:'same-origin',
          headers:{ 'Content-Type':'application/json', Accept:'application/json' },
          body:JSON.stringify({ items:[{ id, quantity:1 }] }),
          signal:controller.signal
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          customerMessage = typeof data.description === 'string' ? data.description : '';
          throw new Error('Cart response requires review.');
        }
        const added = Array.isArray(data.items) ? data.items : [data];
        if (!added.some(item => String(item.variant_id || item.id) === id && item.quantity > 0)) {
          throw new Error('The item could not be confirmed.');
        }
        label.textContent = 'Added';
        this.status.textContent = 'Added. Updating your cart…';
        try {
          sessionStorage.setItem('yatskia:cart-arrival:v1', JSON.stringify({ at:Date.now(), path:cartURL.pathname }));
        } catch { /* Storage restrictions must not prevent navigation. */ }
        window.location.assign(cartURL.href);
      } catch (error) {
        // A failed/aborted response can still have changed the server cart.
        // Never retry automatically or allow checkout with stale totals.
        this.status.textContent = '';
        this.error.textContent = (error.name === 'AbortError' ? 'The connection took too long.' : customerMessage || 'We could not confirm whether the item was added.') + ' Refresh your cart to check its contents before trying again.';
        this.review.href = cartURL.href;
        this.review.hidden = false;
        label.textContent = oldLabel;
        this.error.focus();
      } finally {
        clearTimeout(timeout);
        button.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('yatskia-cart-upsell', YatskiaCartUpsell);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yatskia-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tag = 'yatskia-faq-panel';
    if (!('customElements' in window) || customElements.get(tag)) return;
    customElements.define(tag, class extends HTMLElement {
      connectedCallback() {
        if (this.lifecycle && !this.lifecycle.signal.aborted) return;
        this.lifecycle = new AbortController();
        const signal = this.lifecycle.signal;
        const initialize = () => {
          if (!this.isConnected || signal.aborted) return;
          this.items = Array.from(this.querySelectorAll('[data-faq-item]'));
          this.rows = Array.from(this.querySelectorAll('[data-faq-row]'));
          this.allowMultiple = this.dataset.allowMultiple === 'true';
          this.items.forEach(item => {
            // Close siblings before native activation, so delayed toggle events
            // cannot close the newly selected item in browsers without name groups.
            item.querySelector('summary')?.addEventListener('click', event => {
              if (!event.defaultPrevented && !this.allowMultiple && !item.open) this.closeOthers(item);
            }, { signal });
            item.addEventListener('toggle', () => {
              if (!this.allowMultiple && item.open) this.closeOthers(item);
            }, { signal });
          });
          const firstOpen = this.items.find(item => item.open);
          if (!this.allowMultiple && firstOpen) this.closeOthers(firstOpen);
          this.search = this.querySelector('[data-search]');
          this.lastQuery = null;
          if (this.search) {
            this.clearButton = this.querySelector('[data-clear]');
            this.noResults = this.querySelector('[data-no-results]');
            this.searchStatus = this.querySelector('[data-search-status]');
            this.searchIndex = this.rows.map(row => this.normalize(row.querySelector('.yf-question-text').textContent + ' ' + row.querySelector('.yf-answer').textContent));
            this.isComposing = false;
            // Wait for a completed character before filtering or handling Escape.
            this.search.addEventListener('compositionstart', () => { this.isComposing = true; }, { signal });
            this.search.addEventListener('compositionend', () => {
              this.isComposing = false;
              this.filter();
            }, { signal });
            this.search.addEventListener('input', event => {
              if (!this.isComposing && !event.isComposing) this.filter();
            }, { signal });
            this.clearButton.addEventListener('click', () => this.resetSearch(true), { signal });
            this.search.addEventListener('keydown', event => {
              if (event.defaultPrevented || this.isComposing || event.isComposing) return;
              if (event.key === 'Escape' && this.search.value) {
                event.preventDefault();
                this.resetSearch(true);
              }
            }, { signal });
            this.querySelector('[data-search-wrap]').hidden = false;
            this.filter();
          }
          if (this.hasAttribute('data-editor')) {
            document.addEventListener('shopify:block:select', event => this.selectBlock(event), { signal });
          }
          this.setAttribute('data-ready', '');
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true, signal });
        else queueMicrotask(initialize);
      }
      disconnectedCallback() {
        this.lifecycle?.abort();
        this.removeAttribute('data-ready');
      }
      closeOthers(selected) {
        this.items.forEach(item => { if (item !== selected && item.open) item.open = false; });
      }
      normalize(value) { return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/\s+/g, ' ').trim(); }
      filter() {
        const query = this.normalize(this.search.value);
        const hideClear = !this.search.value;
        if (this.clearButton.hidden !== hideClear) this.clearButton.hidden = hideClear;
        // Case, accents and extra spaces can change without changing the results.
        if (query === this.lastQuery) return;
        this.lastQuery = query;
        const words = query.split(' ').filter(Boolean);
        let count = 0;
        this.rows.forEach((row, index) => {
          const match = words.every(word => this.searchIndex[index].includes(word));
          if (row.hidden !== !match) row.hidden = !match;
          if (match) count++;
        });
        if (this.noResults.hidden !== (count !== 0)) this.noResults.hidden = count !== 0;
        const message = query ? `${count} of ${this.rows.length} questions match` : '';
        if (this.searchStatus.textContent !== message) this.searchStatus.textContent = message;
      }
      resetSearch(focus) {
        if (!this.search) return;
        this.search.value = '';
        this.filter();
        if (focus) this.search.focus({ preventScroll: true });
      }
      selectBlock(event) {
        if (String(event.detail?.sectionId) !== this.dataset.sectionId) return;
        const block = Array.from(this.querySelectorAll('[data-block-id]')).find(row => row.dataset.blockId === String(event.detail.blockId));
        if (!block) return;
        this.resetSearch(false);
        const item = block.querySelector('[data-faq-item]');
        if (item) {
          if (!this.allowMultiple) this.closeOthers(item);
          item.open = true;
        }
        block.scrollIntoView({ behavior: 'instant', block: 'nearest' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yatskia-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!('customElements' in window) || customElements.get('karyliz-video-carousel')) return;
  class KarylizVideoCarousel extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (this.initialized || !this.isConnected) return;
      this.track = this.querySelector('.kv-track');
      if (!this.track) return;
      this.initialized = true;
      this.generation = (this.generation || 0) + 1;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.cards = Array.from(this.querySelectorAll('.kv-card'));
      this.videos = Array.from(this.querySelectorAll('.kv-video'));
      this.previous = this.querySelector('[data-step="-1"]');
      this.next = this.querySelector('[data-step="1"]');
      this.navigation = this.querySelector('.kv-navigation');
      this.counter = this.querySelector('[data-position]');
      this.autoplayButton = this.querySelector('[data-autoplay-toggle]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.connection = navigator.connection;
      this.ratios = new Map(this.videos.map(video => [video, 0]));
      this.pending = new WeakSet();
      this.automatic = new WeakSet();
      this.manual = new WeakSet();
      this.failed = new WeakSet();
      this.allowed = new Set();
      this.animations = new Set();
      this.userPausedAutoplay = false;
      this.userVideo = null;
      this.previous?.addEventListener('click', () => this.scrollByCard(-1), options);
      this.next?.addEventListener('click', () => this.scrollByCard(1), options);
      this.track.addEventListener('scroll', () => this.scheduleNavigation(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const sign = this.geometry?.rtl ? -1 : 1;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.scrollByCard((event.key === 'ArrowRight' ? 1 : -1) * sign);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : sign * this.track.scrollWidth, behavior: this.scrollBehavior() });
        }
      }, options);
      this.autoplayButton?.addEventListener('click', () => {
        this.userPausedAutoplay = !this.userPausedAutoplay;
        this.manual = new WeakSet();
        this.userVideo = null;
        this.allowed.clear();
        this.pauseAll();
        if (!this.userPausedAutoplay) this.failed = new WeakSet();
        this.syncPlayback();
      }, options);
      document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
      const preferencesChanged = () => {
        this.animations.forEach(animation => animation.cancel());
        this.animations.clear();
        this.syncPlayback();
      };
      this.motion.addEventListener('change', preferencesChanged, options);
      this.mobile.addEventListener('change', preferencesChanged, options);
      this.connection?.addEventListener('change', preferencesChanged, options);
      this.videos.forEach(video => {
        video.controls = true;
        video.autoplay = false;
        // A native player interaction suspends autoplay until explicitly resumed.
        video.addEventListener('pointerdown', () => this.takeManualControl(video), options);
        video.addEventListener('keydown', event => {
          if ([' ', 'Enter', 'k', 'K', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) this.takeManualControl(video);
        }, options);
        video.addEventListener('play', () => {
          if (document.hidden || (this.observer && (this.ratios.get(video) || 0) <= 0)) {
            video.pause();
            return;
          }
          if (this.automatic.has(video) && !this.manual.has(video)) {
            if (!this.allowed.has(video) || !this.automaticAllowed() || this.userPausedAutoplay) video.pause();
          } else {
            this.takeManualControl(video);
          }
        }, options);
        video.addEventListener('ended', () => {
          // Loop-off really stops; don't restart the same clip during observer updates.
          if (!video.loop) this.failed.add(video);
        }, options);
        video.addEventListener('error', () => {
          this.failed.add(video);
          this.syncPlayback();
        }, options);
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => this.ratios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0));
          this.syncPlayback();
        }, { threshold: [0, .01, .25, .5, .6, .65, .7, .75, .8, .85, .9, .95, 1] });
        this.videos.forEach(video => this.observer.observe(video));
        this.entranceObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.entranceObserver.unobserve(entry.target);
            if (!this.animationAllowed() || !entry.target.animate) return;
            const frames = entry.target.classList.contains('kv-backdrop')
              ? [{ opacity: 0 }, { opacity: 1 }]
              : [{ opacity: .65, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }];
            const animation = entry.target.animate(frames, { duration: 400, easing: 'ease-out' });
            this.animations.add(animation);
            animation.finished.then(() => this.animations.delete(animation), () => this.animations.delete(animation));
          });
        }, { threshold: .05 });
        this.querySelectorAll('.kv-surface, .kv-backdrop').forEach(node => this.entranceObserver.observe(node));
      }
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => { this.measure(); this.scheduleNavigation(); });
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', () => { this.measure(); this.scheduleNavigation(); }, options);
      }
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest?.('.kv-card');
        if (card && this.contains(card)) card.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
      }, options);
      this.setAttribute('data-ready', '');
      this.measure();
      this.updateNavigation();
      this.updateAutoplayButton();
    }
    animationAllowed() {
      return this.dataset.animations === 'true' && !this.motion.matches &&
        (!this.mobile.matches || this.dataset.mobileAnimations === 'true');
    }
    automaticAllowed() {
      return this.dataset.autoplay === 'true' && this.dataset.editor !== 'true' &&
        !!this.observer && !this.motion.matches && !this.connection?.saveData;
    }
    updateAutoplayButton() {
      if (!this.autoplayButton) return;
      this.autoplayButton.hidden = !this.automaticAllowed() || this.videos.length === 0;
      this.toggleAttribute('data-autoplay-paused', this.userPausedAutoplay);
      this.autoplayButton.querySelector('span').textContent = this.userPausedAutoplay ? 'Resume autoplay' : 'Pause autoplay';
    }
    takeManualControl(video) {
      this.manual.add(video);
      this.automatic.delete(video);
      this.userVideo = video;
      this.userPausedAutoplay = true;
      this.allowed.clear();
      this.videos.forEach(other => { if (other !== video && !other.paused) other.pause(); });
      this.updateAutoplayButton();
    }
    pauseAll() {
      this.videos.forEach(video => { if (!video.paused) video.pause(); });
    }
    syncPlayback() {
      if (!this.initialized) return;
      const previous = this.allowed;
      this.allowed = new Set();
      this.updateAutoplayButton();
      if (document.hidden) { this.pauseAll(); return; }
      // Native playback remains available when automatic playback is disabled.
      if (this.userPausedAutoplay || !this.automaticAllowed()) {
        this.videos.forEach(video => {
          if (!this.manual.has(video) || (this.observer && !(this.ratios.get(video) > 0))) video.pause();
        });
        return;
      }
      const candidates = this.videos.filter(video => (this.ratios.get(video) || 0) >= .65 && !this.failed.has(video) && !this.manual.has(video));
      // Retain a current video on ties to prevent constant switching at rest.
      candidates.sort((a, b) => {
        const difference = (this.ratios.get(b) || 0) - (this.ratios.get(a) || 0);
        if (Math.abs(difference) > .025) return difference;
        return Number(previous.has(b)) - Number(previous.has(a));
      });
      const limit = this.mobile.matches ? 1 : Math.min(2, Math.max(1, Number(this.dataset.limit) || 1));
      this.allowed = new Set(candidates.slice(0, limit));
      this.videos.forEach(video => {
        if (!this.allowed.has(video)) { if (!video.paused) video.pause(); }
        else if (video.paused && !this.pending.has(video)) this.playAutomatic(video);
      });
    }
    playAutomatic(video) {
      const generation = this.generation;
      const pending = this.pending;
      pending.add(video);
      this.automatic.add(video);
      video.muted = true;
      Promise.resolve().then(() => {
        if (!this.initialized || this.generation !== generation || !this.allowed.has(video) || this.userPausedAutoplay || document.hidden) return;
        return video.play();
      }).then(() => {
        if (this.generation !== generation) return;
        if (!this.initialized || document.hidden || (!this.manual.has(video) && !this.allowed.has(video))) video.pause();
      }).catch(error => {
        // Browser policy/network errors leave the native play button available.
        if (this.generation === generation && error.name !== 'AbortError') this.failed.add(video);
      }).finally(() => {
        pending.delete(video);
      });
    }
    measure() {
      const style = getComputedStyle(this.track);
      this.geometry = {
        rtl: style.direction === 'rtl',
        left: parseFloat(style.paddingLeft) || 0,
        right: parseFloat(style.paddingRight) || 0,
        step: (this.cards[0]?.offsetWidth || 0) + (parseFloat(style.columnGap) || 0)
      };
    }
    scheduleNavigation() {
      if (this.navigationFrame) return;
      this.navigationFrame = requestAnimationFrame(() => { this.navigationFrame = null; this.updateNavigation(); });
    }
    updateNavigation() {
      if (!this.cards.length || !this.geometry) return;
      const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
      if (this.navigation) this.navigation.hidden = !overflow;
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const offset = Math.min(maxScroll, Math.abs(this.track.scrollLeft));
      if (this.previous) this.previous.disabled = !overflow || offset < 2;
      if (this.next) this.next.disabled = !overflow || offset >= maxScroll - 2;
      if (this.counter) {
        const index = Math.min(this.cards.length, Math.floor((offset + 2) / Math.max(1, this.geometry.step)) + 1);
        this.counter.textContent = String(index);
      }
    }
    scrollBehavior() { return this.motion.matches ? 'auto' : 'smooth'; }
    scrollByCard(direction) {
      if (!this.geometry) return;
      this.track.scrollBy({ left: direction * this.geometry.step * (this.geometry.rtl ? -1 : 1), behavior: this.scrollBehavior() });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.navigationFrame);
      this.initialized = false;
      this.generation = (this.generation || 0) + 1;
      this.events?.abort();
      this.observer?.disconnect();
      this.entranceObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      this.allowed?.clear();
      if (this.videos) this.pauseAll();
      this.navigationFrame = null;
      this.removeAttribute('data-ready');
    }
  }
  customElements.define('karyliz-video-carousel', KarylizVideoCarousel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yatskia-related-products-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var referralStorageKey = 'yu_related_product_referral';

    function sendAnalyticsEvent(eventName, ecommerce) {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, ecommerce);
        return;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: eventName,
        ecommerce: ecommerce
      });
    }

    function createAnalyticsItem(card, root) {
      var item = {
        item_id: card.dataset.productId || '',
        item_name: card.dataset.productTitle || '',
        item_list_id: 'related_products',
        item_list_name: root.dataset.yuListName || 'Related products',
        index: Number(card.dataset.productPosition || 1),
        quantity: 1
      };
      var price = Number(card.dataset.productPrice);

      if (card.dataset.variantId) item.item_variant = card.dataset.variantId;
      if (card.dataset.productVendor) item.item_brand = card.dataset.productVendor;
      if (card.dataset.productCategory) item.item_category = card.dataset.productCategory;
      if (Number.isFinite(price)) item.price = price;

      return item;
    }

    function analyticsPayload(root, items) {
      return {
        currency: root.dataset.yuCurrency || '',
        item_list_id: 'related_products',
        item_list_name: root.dataset.yuListName || 'Related products',
        items: items
      };
    }

    function normalizedPath(url) {
      try {
        var path = new URL(url, window.location.origin).pathname;
        return path.length > 1 ? path.replace(/\/$/, '') : path;
      } catch (error) {
        return '';
      }
    }

    function saveReferral(link, item, root) {
      try {
        window.sessionStorage.setItem(referralStorageKey, JSON.stringify({
          destination: normalizedPath(link.href),
          currency: root.dataset.yuCurrency || '',
          item_list_name: root.dataset.yuListName || 'Related products',
          item: item,
          timestamp: Date.now()
        }));
      } catch (error) {
        /* Storage can be unavailable in strict privacy modes. */
      }
    }

    function trackReferralAddToCart(form) {
      if (!form || !form.matches('form[action*="/cart/add"]')) return;

      try {
        var storedValue = window.sessionStorage.getItem(referralStorageKey);
        if (!storedValue) return;

        var referral = JSON.parse(storedValue);
        var isRecent = Date.now() - Number(referral.timestamp || 0) < 4 * 60 * 60 * 1000;
        var isDestination = normalizedPath(window.location.href) === referral.destination;

        if (!isRecent || !isDestination || !referral.item) return;

        sendAnalyticsEvent('related_product_add_to_cart', {
          currency: referral.currency || '',
          item_list_id: 'related_products',
          item_list_name: referral.item_list_name || 'Related products',
          items: [referral.item]
        });

        window.sessionStorage.removeItem(referralStorageKey);
      } catch (error) {
        /* A malformed or unavailable storage entry should never block purchase actions. */
      }
    }

    function initializeAttributionTracking() {
      if (document.documentElement.dataset.yuAttributionReady === 'true') return;

      document.documentElement.dataset.yuAttributionReady = 'true';

      document.addEventListener('click', function (event) {
        var submitControl = event.target.closest('button[type="submit"], input[type="submit"], [name="add"]');
        if (!submitControl) return;

        trackReferralAddToCart(submitControl.form || submitControl.closest('form'));
      }, true);

      document.addEventListener('submit', function (event) {
        trackReferralAddToCart(event.target);
      }, true);
    }

    function initializeAnalytics(root) {
      if (root.dataset.yuAnalytics !== 'true') return;

      initializeAttributionTracking();

      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-yu-related-card]'));
      if (!cards.length) return;

      function trackView() {
        if (root.dataset.yuViewTracked === 'true') return;

        root.dataset.yuViewTracked = 'true';
        sendAnalyticsEvent('view_item_list', analyticsPayload(root, cards.map(function (card) {
          return createAnalyticsItem(card, root);
        })));

        if (root.yuRelatedIntersectionObserver) {
          root.yuRelatedIntersectionObserver.disconnect();
          root.yuRelatedIntersectionObserver = null;
        }
      }

      if ('IntersectionObserver' in window) {
        var intersectionObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) trackView();
          });
        }, { threshold: 0.2 });

        intersectionObserver.observe(root);
        root.yuRelatedIntersectionObserver = intersectionObserver;
      } else {
        trackView();
      }

      root.yuRelatedClickHandler = function (event) {
        var link = event.target.closest('[data-yu-related-link]');
        if (!link || !root.contains(link)) return;

        var card = link.closest('[data-yu-related-card]');
        if (!card) return;

        var item = createAnalyticsItem(card, root);
        sendAnalyticsEvent('select_item', analyticsPayload(root, [item]));
        saveReferral(link, item, root);
      };

      root.addEventListener('click', root.yuRelatedClickHandler);
    }

    function initializeCarousel(root) {
      if (!root || root.dataset.yuCarouselReady === 'true') return;

      var track = root.querySelector('[data-yu-related-track]');
      var nav = root.querySelector('[data-yu-related-nav]');
      var previousButton = root.querySelector('[data-yu-related-prev]');
      var nextButton = root.querySelector('[data-yu-related-next]');

      if (!track || !nav || !previousButton || !nextButton) return;

      root.dataset.yuCarouselReady = 'true';
      var animationFrame = null;

      function maximumScroll() {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      }

      function updateControls() {
        var maxScroll = maximumScroll();
        var hasOverflow = maxScroll > 4;

        nav.hidden = !hasOverflow;
        previousButton.disabled = !hasOverflow || track.scrollLeft <= 4;
        nextButton.disabled = !hasOverflow || track.scrollLeft >= maxScroll - 4;
      }

      function cardStep() {
        var firstCard = track.querySelector('[data-yu-related-card]');

        if (!firstCard) return track.clientWidth;

        var trackStyle = window.getComputedStyle(track);
        var gap = parseFloat(trackStyle.columnGap || trackStyle.gap) || 0;

        return firstCard.getBoundingClientRect().width + gap;
      }

      function scrollByCard(direction) {
        track.scrollBy({
          left: direction * cardStep(),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      root.yuRelatedKeydownHandler = function (event) {
        if (event.target !== track || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;

        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          scrollByCard(event.key === 'ArrowLeft' ? -1 : 1);
        } else if (event.key === 'Home') {
          event.preventDefault();
          track.scrollTo({ left: 0, behavior: 'auto' });
        } else if (event.key === 'End') {
          event.preventDefault();
          track.scrollTo({ left: maximumScroll(), behavior: 'auto' });
        }
      };

      function handleScroll() {
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        animationFrame = window.requestAnimationFrame(updateControls);
      }

      previousButton.addEventListener('click', function () {
        scrollByCard(-1);
      });

      nextButton.addEventListener('click', function () {
        scrollByCard(1);
      });

      track.addEventListener('scroll', handleScroll, { passive: true });
      track.addEventListener('keydown', root.yuRelatedKeydownHandler);

      if ('ResizeObserver' in window) {
        var resizeObserver = new ResizeObserver(updateControls);
        resizeObserver.observe(track);
        root.yuRelatedResizeObserver = resizeObserver;
      } else {
        window.addEventListener('resize', updateControls);
        root.yuRelatedResizeFallback = updateControls;
      }

      updateControls();
      initializeAnalytics(root);
    }

    function initializeAll(scope) {
      if (!scope) return;

      if (scope.matches && scope.matches('[data-yu-related-carousel]')) {
        initializeCarousel(scope);
      }

      scope.querySelectorAll('[data-yu-related-carousel]').forEach(initializeCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAll(document);
      });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var root = event.target.querySelector('[data-yu-related-carousel]');

      if (!root) return;

      if (root.yuRelatedResizeObserver) {
        root.yuRelatedResizeObserver.disconnect();
      }

      if (root.yuRelatedResizeFallback) {
        window.removeEventListener('resize', root.yuRelatedResizeFallback);
      }

      if (root.yuRelatedIntersectionObserver) {
        root.yuRelatedIntersectionObserver.disconnect();
      }

      if (root.yuRelatedClickHandler) {
        root.removeEventListener('click', root.yuRelatedClickHandler);
      }

      if (root.yuRelatedKeydownHandler) {
        var track = root.querySelector('[data-yu-related-track]');
        if (track) track.removeEventListener('keydown', root.yuRelatedKeydownHandler);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yatskia-stories"] && !Shopify.designMode) return;
  try {
    
/* Yatskia Stories: progressively enhanced, dependency-free, section-safe. */
(() => {
  'use strict';
  if (customElements.get('yatskia-stories-page') && customElements.get('yatskia-video-carousel')) return;

  // Restore existing inline overflow values, including another theme's lock.
  const locks = new Set();
  let previousOverflow = '';
  let previousPriority = '';
  function lock(owner) {
    if (locks.has(owner)) return;
    if (!locks.size) {
      previousOverflow = document.body.style.getPropertyValue('overflow');
      previousPriority = document.body.style.getPropertyPriority('overflow');
      document.body.style.setProperty('overflow', 'hidden', previousPriority);
    }
    locks.add(owner);
    document.dispatchEvent(new Event('ys:dialog-state'));
  }
  function unlock(owner) {
    if (!locks.delete(owner) || locks.size) return;
    // Do not overwrite a different inline value applied by the theme meanwhile.
    if (document.body.style.getPropertyValue('overflow') === 'hidden' &&
        document.body.style.getPropertyPriority('overflow') === previousPriority) {
      if (previousOverflow) document.body.style.setProperty('overflow', previousOverflow, previousPriority);
      else document.body.style.removeProperty('overflow');
    }
    document.dispatchEvent(new Event('ys:dialog-state'));
  }

  class YatskiaStories extends HTMLElement {
    connectedCallback() {
      this.onReady = () => { if (this.isConnected) this.init(); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
      else this.init();
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.onReady);
      this.controller?.abort();
      this.dialogs?.forEach(dialog => {
        if (dialog.open) dialog.close();
        unlock(dialog);
      });
      this.initialized = false;
    }

    init() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.cards = [...this.querySelectorAll('.ys-review-card[data-review-card]')];
      this.filters = [...this.querySelectorAll('.ys-filter[data-filter]')];
      this.rating = this.querySelector('.ys-rating-select select');
      this.result = this.querySelector('[data-review-result]');
      this.empty = this.querySelector('.ys-empty-state');
      this.topic = 'all';
      if (this.rating) this.rating.value = 'all';
      this.dialogTriggers = new WeakMap();
      this.templates = new Map([...this.querySelectorAll('template[data-story-template]')]
        .map(template => [template.dataset.storyTemplate, template]));
      this.dialogs = [...this.querySelectorAll('.ys-story-dialog, .ys-small-dialog')];
      this.storyDialog = this.querySelector('.ys-story-dialog');
      this.shareDialog = this.querySelector('.ys-small-dialog[id$="-share-dialog"]');
      this.aboutDialog = this.querySelector('.ys-small-dialog[id$="-about-dialog"]');
      this.dialogBody = this.querySelector('.ys-story-dialog-body');
      this.menu = this.querySelector('.ys-menu-toggle');
      this.nav = this.querySelector('.ys-mobile-nav');
      this.canDialog = typeof HTMLDialogElement !== 'undefined' && typeof HTMLDialogElement.prototype.showModal === 'function';

      // Without JS the navigation and all review cards remain available.
      const filterControls = this.querySelector('[data-filter-controls]');
      if (filterControls) filterControls.hidden = !this.cards.length;
      if (this.menu && this.nav) {
        this.menu.hidden = false;
        this.setMenu(false);
      }
      this.rating?.addEventListener('change', () => this.filter(), { signal });
      this.addEventListener('click', event => {
        if (event.target instanceof Element && !event.target.closest('.ys-app-reviews')) this.handleClick(event);
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.defaultPrevented || event.target.closest?.('.ys-app-reviews')) return;
        if (event.key === 'Escape' && this.nav && !this.nav.hidden && !this.querySelector('dialog[open]')) {
          this.setMenu(false);
          this.menu.focus();
        }
      }, { signal });

      this.dialogs.forEach(dialog => {
        dialog.querySelector('[data-close]')?.addEventListener('click', () => dialog.close(), { signal });
        // A drag that starts inside a dialog must not dismiss it on release.
        let startedOutside = false;
        const outside = e => {
          const box = dialog.getBoundingClientRect();
          return e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom;
        };
        dialog.addEventListener('pointerdown', e => { startedOutside = e.target === dialog && outside(e); }, { signal });
        dialog.addEventListener('click', e => {
          if (startedOutside && e.target === dialog && outside(e)) dialog.close();
          startedOutside = false;
        }, { signal });
        dialog.addEventListener('close', () => {
          // A queued close event must not unlock a dialog that has reopened.
          if (dialog.open) return;
          unlock(dialog);
          const trigger = this.dialogTriggers.get(dialog);
          if (this.isConnected && !this.querySelector('dialog[open]') && trigger?.isConnected) {
            trigger.focus({ preventScroll: true });
          }
        }, { signal });
      });

      // The custom element reconnects after Shopify replaces section HTML.
      // Selecting a filtered review in the editor makes its block visible.
      document.addEventListener('shopify:block:select', event => {
        const blockId = event.detail?.blockId;
        const block = [...this.querySelectorAll('[data-block-id]')].find(el => el.dataset.blockId === blockId);
        if (!block) return;
        this.dialogs.forEach(d => { if (d.open) d.close(); });
        if (block.matches('[data-review-card]')) this.resetFilters();
        if (block.tagName === 'DETAILS') block.open = true;
        block.scrollIntoView({ block: 'center', behavior: 'auto' });
      }, { signal });
      document.addEventListener('shopify:section:unload', event => {
        if (String(event.detail?.sectionId) === this.dataset.sectionId) {
          this.dialogs.forEach(d => {
            if (d.open) d.close();
            unlock(d);
          });
        }
      }, { signal });
      this.filter();
    }

    handleClick(event) {
      if (!(event.target instanceof Element)) return;
      const trigger = event.target.closest('a,button');
      if (!trigger || !this.contains(trigger)) return;
      if (trigger.matches('[data-filter]')) {
        this.topic = trigger.dataset.filter;
        this.filter();
        return;
      }
      if (trigger.id === this.id + '-reset-filters') {
        this.resetFilters();
        this.filters[0]?.focus();
        return;
      }
      if (trigger === this.menu) {
        this.setMenu(this.menu.getAttribute('aria-expanded') !== 'true');
        return;
      }
      if (this.nav?.contains(trigger)) this.setMenu(false);
      // Preserve new-tab and modifier-key behavior for the source/contact links.
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !this.canDialog) return;
      if (trigger.hasAttribute('data-story')) {
        const template = this.templates.get(trigger.dataset.story);
        if (!template || !this.storyDialog || !this.dialogBody) return;
        event.preventDefault();
        this.dialogBody.replaceChildren(template.content.cloneNode(true));
        const heading = this.dialogBody.querySelector('[data-dialog-heading]');
        if (heading) heading.id = this.id + '-story-dialog-title';
        this.dialogBody.classList.toggle('ys-no-photo', !this.dialogBody.querySelector('.ys-story-dialog-image'));
        this.openDialog(this.storyDialog, trigger);
      } else if (trigger.hasAttribute('data-share') && this.shareDialog) {
        event.preventDefault();
        this.openDialog(this.shareDialog, trigger);
      } else if (trigger.hasAttribute('data-about') && this.aboutDialog) {
        event.preventDefault();
        this.openDialog(this.aboutDialog, trigger);
      }
    }

    setMenu(open) {
      if (!this.menu || !this.nav) return;
      this.nav.hidden = !open;
      this.menu.setAttribute('aria-expanded', String(open));
      this.menu.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    }

    openDialog(dialog, trigger) {
      if (!dialog || dialog.open) return;
      this.dialogTriggers.set(dialog, trigger);
      dialog.showModal();
      dialog.scrollTop = 0;
      lock(dialog);
      dialog.querySelector('[data-close]')?.focus({ preventScroll: true });
    }

    resetFilters() {
      this.topic = 'all';
      if (this.rating) this.rating.value = 'all';
      this.filter();
    }

    filter() {
      const rating = this.rating?.value || 'all';
      let count = 0;
      this.cards.forEach(card => {
        const visible = (this.topic === 'all' || card.dataset.topic === this.topic) && (rating === 'all' || card.dataset.rating === rating);
        card.hidden = !visible;
        if (visible) count++;
      });
      this.filters.forEach(button => {
        const active = button.dataset.filter === this.topic;
        button.classList.toggle('ys-is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      if (this.result) this.result.textContent = `${count} selected ${count === 1 ? 'story' : 'stories'}`;
      if (this.empty) this.empty.hidden = count > 0;
    }
  }
  if (!customElements.get('yatskia-stories-page')) customElements.define('yatskia-stories-page', YatskiaStories);

  /* Visible muted previews + continuous scrolling. No external slider library. */
  class YatskiaVideoCarousel extends HTMLElement {
    connectedCallback() {
      this.ready = () => { if (this.isConnected) this.init(); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.ready, { once: true });
      else this.init();
    }

    init() {
      if (this.controller) return;
      this.track = this.querySelector('.ys-video-track');
      this.dialog = this.querySelector('.ys-video-dialog');
      if (!this.track || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const on = (target, type, fn, options = {}) => target.addEventListener(type, fn, { ...options, signal });
      this.originals = [...this.track.children];
      this.originals.forEach((card, index) => { card.dataset.videoIndex = index; });
      this.toolbar = this.querySelector('[data-video-toolbar]');
      this.motionButton = this.querySelector('[data-video-motion]');
      this.previous = this.querySelector('[data-video-prev]');
      this.next = this.querySelector('[data-video-next]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.autoPlay = this.dataset.autoPlay !== 'false';
      this.autoScroll = this.dataset.autoScroll !== 'false';
      this.speed = Math.max(10, Math.min(50, Number(this.dataset.speed) || 28));
      this.visible = new Set();
      this.pending = new WeakMap();
      this.blocked = new WeakSet();
      this.userPaused = false;
      this.pageActive = true;
      this.onScreen = false;
      this.hover = this.hasFocus = this.touching = this.resting = this.editorLocked = false;
      this.toolbar.hidden = !this.originals.length;
      this.classList.add('ys-video-ready');

      if ('IntersectionObserver' in window) {
        this.mediaObserver = new IntersectionObserver(entries => {
          entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
            if (isIntersecting && intersectionRatio >= .08) this.visible.add(target);
            else this.visible.delete(target);
          });
          this.sync();
        }, { threshold: [0, .08] });
        this.sectionObserver = new IntersectionObserver(entries => {
          this.onScreen = entries[0].isIntersecting;
          this.sync();
        });
        this.sectionObserver.observe(this.track);
      }

      on(this.motionButton, 'click', () => {
        this.userPaused = !this.userPaused;
        if (!this.userPaused) {
          this.hasFocus = false;
          this.blocked = new WeakSet();
        }
        this.updateMotionButton();
        this.sync();
      });
      on(this.previous, 'click', () => this.move(-1));
      on(this.next, 'click', () => this.move(1));
      on(this.track, 'pointerenter', event => { if (event.pointerType === 'mouse') { this.hover = true; this.sync(); } });
      on(this.track, 'pointerleave', () => { this.hover = false; this.sync(); });
      on(this.track, 'pointerdown', () => { this.touching = true; this.sync(); }, { passive: true });
      const release = () => { if (this.touching) { this.touching = false; this.rest(); } };
      on(window, 'pointerup', release, { passive: true });
      on(window, 'pointercancel', release, { passive: true });
      on(this.track, 'wheel', () => this.rest(), { passive: true });
      on(this, 'focusin', () => { this.hasFocus = true; this.sync(); });
      on(this, 'focusout', event => { if (!this.contains(event.relatedTarget)) { this.hasFocus = false; this.sync(); } });
      on(this.track, 'scroll', () => {
        if (!this.looping) this.updateNavigation();
      }, { passive: true });
      on(this.track, 'keydown', event => {
        if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.move(event.key === 'ArrowLeft' ? -1 : 1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault(); this.scrollToCard(event.key === 'Home' ? 0 : this.originals.length - 1);
        }
      });
      on(this.track, 'click', event => {
        const button = event.target.closest?.('[data-video-open]');
        if (button) this.openVideo(button.closest('[data-video-card]'), button);
      });
      on(this.querySelector('[data-video-close]'), 'click', () => this.dialog.close());
      let backdropDown = false;
      const outside = event => {
        const r = this.dialog.getBoundingClientRect();
        return event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom;
      };
      on(this.dialog, 'pointerdown', e => { backdropDown = e.target === this.dialog && outside(e); });
      on(this.dialog, 'click', e => {
        if (backdropDown && e.target === this.dialog && outside(e)) this.dialog.close();
        backdropDown = false;
      });
      on(this.dialog, 'close', () => { if (!this.dialog.open) this.closeVideo(); });
      on(document, 'ys:dialog-state', () => this.sync());
      on(document, 'visibilitychange', () => this.sync());
      on(window, 'pagehide', () => {
        this.pageActive = false;
        this.pauseAll();
        this.dialog.querySelector('video')?.pause();
      });
      on(window, 'pageshow', () => { this.pageActive = true; this.sync(); });
      on(this.motion, 'change', () => this.layout());
      on(document, 'shopify:block:select', event => {
        const index = this.originals.findIndex(card => card.dataset.videoBlockId === String(event.detail?.blockId));
        if (index < 0) return;
        this.editorLocked = true;
        this.sync();
        this.scrollToCard(index);
        this.scrollIntoView({ block: 'center', behavior: 'auto' });
      });
      on(document, 'shopify:block:deselect', event => {
        if (!this.originals.some(card => card.dataset.videoBlockId === String(event.detail?.blockId))) return;
        this.editorLocked = false;
        this.sync();
      });
      on(document, 'shopify:section:unload', event => { if (String(event.detail?.sectionId) === this.dataset.sectionId) this.cleanup(); });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          if (this.track.clientWidth !== this.lastWidth) this.layout();
        });
        this.resizeObserver.observe(this.track);
      } else on(window, 'resize', () => this.layout());
      this.layout();
    }

    layout() {
      if (!this.controller) return;
      const previousStep = this.step;
      let previousPosition = previousStep ? Math.max(0, this.track.scrollLeft) / previousStep : 0;
      // A visible loop copy represents the same original when motion is disabled.
      if (this.looping && this.originals.length) previousPosition %= this.originals.length;
      this.pauseAll();
      this.mediaObserver?.disconnect();
      this.visible.clear();
      this.pending = new WeakMap();
      this.track.querySelectorAll('[data-video-clone]').forEach(card => card.remove());
      this.lastWidth = this.track.clientWidth;
      if (!this.originals.length) {
        this.videos = [];
        this.toolbar.hidden = true;
        return;
      }
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.step = this.originals[0].getBoundingClientRect().width + gap;
      this.cycle = this.step * this.originals.length;
      this.looping = this.lastWidth > 0 && this.step > 0 && this.autoScroll && !this.motion.matches && this.originals.length > 1 && this.originals.every(card => card.querySelector('video'));
      this.track.classList.toggle('ys-video-loop', this.looping);
      if (this.looping) {
        // Only enough copies to cover one wrap; copies are excluded from keyboard navigation.
        const copies = Math.ceil((this.lastWidth + gap) / this.step);
        for (let index = 0; index < copies; index++) {
          const card = this.originals[index % this.originals.length];
          const copy = card.cloneNode(true);
          copy.dataset.videoClone = '';
          copy.setAttribute('aria-hidden', 'true');
          copy.removeAttribute('data-video-block-id');
          copy.removeAttribute('id');
          [...copy.attributes].filter(a => a.name.startsWith('data-shopify')).forEach(a => copy.removeAttribute(a.name));
          copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
          copy.querySelectorAll('button,video,a,[tabindex]').forEach(el => el.setAttribute('tabindex', '-1'));
          this.track.append(copy);
        }
      }
      this.videos = [...this.track.querySelectorAll('video')];
      this.videos.forEach(video => {
        video.controls = false;
        video.muted = true;
        video.loop = true;
        video.closest('[data-video-card]').querySelector('[data-video-open]').hidden = false;
        this.mediaObserver?.observe(video);
      });
      const position = this.looping ? previousPosition % this.originals.length : Math.min(previousPosition, this.originals.length - 1);
      this.track.scrollLeft = position * this.step;
      this.maxScroll = Math.max(0, this.track.scrollWidth - this.lastWidth);
      const canBrowse = this.looping || this.maxScroll > 2;
      this.updateNavigation();
      this.setControlState(this.motionButton, this.motion.matches || (!this.autoPlay && !this.looping) || !this.videos.length);
      this.toolbar.hidden = !canBrowse && this.motionButton.hidden;
      this.updateMotionButton();
      this.sync();
    }

    setControlState(button, hidden, disabled = false) {
      // Keep keyboard focus usable before an active control becomes unavailable.
      if ((hidden || disabled) && document.activeElement === button) {
        this.track.focus({ preventScroll: true });
      }
      button.hidden = hidden;
      button.disabled = disabled;
    }

    updateNavigation() {
      const canBrowse = this.looping || this.maxScroll > 2;
      const position = Math.max(0, Math.min(this.track.scrollLeft, this.maxScroll));
      this.setControlState(this.previous, !canBrowse, !this.looping && position < 2);
      this.setControlState(this.next, !canBrowse, !this.looping && position >= this.maxScroll - 2);
    }

    updateMotionButton() {
      this.motionButton.setAttribute('aria-pressed', String(this.userPaused));
      this.motionButton.setAttribute('aria-label', this.userPaused ? 'Resume video previews and scrolling' : 'Pause video previews and scrolling');
      this.motionButton.title = this.userPaused ? 'Resume motion' : 'Pause motion';
    }

    motionEnabled() {
      return Boolean(this.controller && this.isConnected && this.pageActive && this.onScreen &&
        !document.hidden && !this.userPaused && !this.motion.matches && !locks.size &&
        !this.dialog.open && !this.editorLocked);
    }

    shouldPlay(video) {
      return this.motionEnabled() && this.autoPlay && this.visible.has(video) && this.track.contains(video);
    }

    sync() {
      if (!this.controller) return;
      const enabled = this.motionEnabled();
      this.videos?.forEach(video => {
        if (this.shouldPlay(video)) {
          if (video.paused && !this.pending.has(video) && !this.blocked.has(video)) {
            const controller = this.controller;
            const pending = this.pending;
            const attempt = { interrupted: false };
            pending.set(video, attempt);
            Promise.resolve(video.play()).then(() => {
              // A previous section instance must never restart a detached video.
              if (!this.shouldPlay(video)) video.pause();
            }).catch(error => {
              if (this.controller === controller && error.name !== 'AbortError') this.blocked.add(video);
            }).finally(() => {
              pending.delete(video);
              // A quick pause/resume can finish before an interrupted play settles.
              if (attempt.interrupted && this.controller === controller && this.pending === pending &&
                  this.shouldPlay(video) && video.paused && !this.blocked.has(video)) this.sync();
            });
          }
        } else {
          const attempt = this.pending.get(video);
          if (attempt) attempt.interrupted = true;
          if (!video.paused) video.pause();
        }
      });
      if (!enabled || !this.looping || this.hover || this.hasFocus || this.touching || this.resting) {
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        return;
      }
      // Playback visibility updates can reuse the running scroll animation.
      if (this.frame) return;
      let previous;
      let position = this.track.scrollLeft;
      const tick = time => {
        if (!this.motionEnabled() || !this.looping || this.hover || this.hasFocus || this.touching || this.resting) {
          this.frame = 0;
          return;
        }
        const delta = previous === undefined ? 0 : Math.min(64, time - previous);
        previous = time;
        position = (position + this.speed * delta / 1000) % this.cycle;
        this.track.scrollLeft = position;
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }

    rest() {
      this.resting = true;
      clearTimeout(this.restTimer);
      this.sync();
      this.restTimer = setTimeout(() => { this.resting = false; this.sync(); }, 5000);
    }

    move(direction) {
      if (!this.step) return;
      this.rest();
      if (this.looping) {
        if (this.track.scrollLeft >= this.cycle) this.track.scrollLeft %= this.cycle;
        if (direction < 0 && this.track.scrollLeft < 2) this.track.scrollLeft = this.cycle;
      }
      const position = (Math.round(this.track.scrollLeft / this.step) + direction) * this.step;
      this.track.scrollTo({ left: position, behavior: this.motion.matches ? 'auto' : 'smooth' });
    }

    scrollToCard(index) {
      this.track.scrollTo({ left: index * this.step, behavior: 'auto' });
    }

    openVideo(card, button) {
      if (!card || this.dialog.open) return;
      const original = this.originals[Number(card.dataset.videoIndex)];
      const source = original?.querySelector('video');
      if (!source) return;
      this.pauseAll();
      this.trigger = original.querySelector('[data-video-open]') || button;
      const video = source.cloneNode(true);
      video.removeAttribute('tabindex');
      video.removeAttribute('loading');
      video.removeAttribute('muted');
      video.removeAttribute('loop');
      video.removeAttribute('id');
      video.muted = video.defaultMuted = false;
      video.loop = false;
      video.controls = true;
      video.preload = 'metadata';
      this.dialog.querySelector('h2').textContent = source.getAttribute('aria-label') || 'Customer video';
      this.dialog.querySelector('.ys-video-dialog-body').replaceChildren(video);
      this.dialog.showModal();
      lock(this.dialog);
      this.querySelector('[data-video-close]').focus({ preventScroll: true });
      this.sync();
      // Playback with sound is started by the visitor's tap, never by the carousel.
      video.play()?.catch(() => {});
    }

    closeVideo(restoreFocus = true) {
      const video = this.dialog?.querySelector('video');
      if (video) { video.pause(); video.remove(); }
      if (this.dialog) unlock(this.dialog);
      if (restoreFocus && this.isConnected && this.trigger?.isConnected && !locks.size) {
        const index = Number(this.trigger.closest('[data-video-card]').dataset.videoIndex);
        this.scrollToCard(index);
        this.trigger.focus({ preventScroll: true });
      }
      this.trigger = null;
      this.sync();
    }

    pauseAll() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.videos?.forEach(video => {
        const attempt = this.pending?.get(video);
        if (attempt) attempt.interrupted = true;
        if (!video.paused) video.pause();
      });
    }

    cleanup() {
      document.removeEventListener('DOMContentLoaded', this.ready);
      this.pauseAll();
      this.controller?.abort();
      this.controller = null;
      this.pageActive = false;
      this.mediaObserver?.disconnect();
      this.sectionObserver?.disconnect();
      this.resizeObserver?.disconnect();
      clearTimeout(this.restTimer);
      if (this.dialog?.open) this.dialog.close();
      this.closeVideo(false);
      this.track?.querySelectorAll('[data-video-clone]').forEach(card => card.remove());
      this.track?.classList.remove('ys-video-loop');
      this.visible?.clear();
      this.videos = [];
      this.step = 0;
      this.originals?.forEach(card => {
        const video = card.querySelector('video');
        if (video) video.controls = true;
        const button = card.querySelector('[data-video-open]');
        if (button) button.hidden = true;
      });
      if (this.toolbar) this.toolbar.hidden = true;
      this.classList.remove('ys-video-ready');
    }

    disconnectedCallback() { this.cleanup(); }
  }
  if (!customElements.get('yatskia-video-carousel')) customElements.define('yatskia-video-carousel', YatskiaVideoCarousel);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yatskia-video-carasol"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!('customElements' in window) || customElements.get('karyliz-video-carousel')) return;
  class KarylizVideoCarousel extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (this.initialized || !this.isConnected) return;
      this.track = this.querySelector('.kv-track');
      if (!this.track) return;
      this.initialized = true;
      this.generation = (this.generation || 0) + 1;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.cards = Array.from(this.querySelectorAll('.kv-card'));
      this.videos = Array.from(this.querySelectorAll('.kv-video'));
      this.cardVideos = this.cards.map(card => card.querySelector('.kv-video'));
      this.videoIndexes = new Map();
      this.cardVideos.forEach((video, index) => { if (video) this.videoIndexes.set(video, index); });
      this.previous = this.querySelector('[data-step="-1"]');
      this.next = this.querySelector('[data-step="1"]');
      this.navigation = this.querySelector('.kv-navigation');
      this.counter = this.querySelector('[data-position]');
      this.dots = Array.from(this.querySelectorAll('[data-slide]'));
      this.dotsContainer = this.querySelector('.kv-dots');
      this.players = new Map();
      this.playerUpdates = new Set();
      this.manualRequests = new WeakMap();
      this.currentIndex = -1;
      this.preferredIndex = 0;
      this.autoplayButton = this.querySelector('[data-autoplay-toggle]');
      this.autoplayText = this.autoplayButton?.querySelector('span');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.connection = navigator.connection;
      this.ratios = new Map(this.videos.map(video => [video, 0]));
      this.pending = new WeakSet();
      this.automatic = new WeakSet();
      this.manual = new WeakSet();
      this.failed = new WeakSet();
      this.allowed = new Set();
      this.animations = new Set();
      this.userPausedAutoplay = false;
      this.userVideo = null;
      this.previous?.addEventListener('click', () => this.scrollByCard(-1), options);
      this.next?.addEventListener('click', () => this.scrollByCard(1), options);
      this.track.addEventListener('scroll', () => this.scheduleNavigation(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const sign = this.geometry?.rtl ? -1 : 1;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.scrollByCard((event.key === 'ArrowRight' ? 1 : -1) * sign);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.preferredIndex = -1;
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : sign * this.track.scrollWidth, behavior: this.scrollBehavior() });
        }
      }, options);
      this.autoplayButton?.addEventListener('click', () => {
        this.userPausedAutoplay = !this.userPausedAutoplay;
        this.manual = new WeakSet();
        this.userVideo = null;
        this.allowed.clear();
        this.pauseAll();
        if (!this.userPausedAutoplay) this.failed = new WeakSet();
        this.syncPlayback();
      }, options);
      this.dots.forEach(button => button.addEventListener('click', () => this.goToCard(Number(button.dataset.slide)), options));
      this.track.addEventListener('wheel', () => { this.preferredIndex = -1; }, { ...options, passive: true });
      this.track.addEventListener('touchstart', () => { this.preferredIndex = -1; }, { ...options, passive: true });
      document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
      // Shared document handlers avoid installing these once for every video.
      const finishSeeking = () => {
        this.players.forEach((player, video) => {
          if (!player.seeking) return;
          player.seeking = false;
          this.schedulePlayerUpdate(video);
        });
      };
      document.addEventListener('pointerup', finishSeeking, options);
      document.addEventListener('pointercancel', finishSeeking, options);
      document.addEventListener('fullscreenchange', () => {
        this.players.forEach(player => {
          const label = document.fullscreenElement === player.media ? 'Exit fullscreen' : 'Open video fullscreen';
          if (player.fullscreen.getAttribute('aria-label') !== label) player.fullscreen.setAttribute('aria-label', label);
        });
      }, options);
      const preferencesChanged = () => {
        this.animations.forEach(animation => animation.cancel());
        this.animations.clear();
        this.syncPlayback();
      };
      this.motion.addEventListener('change', preferencesChanged, options);
      this.mobile.addEventListener('change', preferencesChanged, options);
      this.connection?.addEventListener('change', preferencesChanged, options);
      this.videos.forEach(video => {
        video.controls = true;
        video.autoplay = false;
        // Custom playback is handled by click/buttons. A pointerdown may be a
        // carousel swipe, so only the native fallback claims that interaction.
        video.addEventListener('pointerdown', () => {
          if (video.controls) this.takeManualControl(video);
        }, options);
        video.addEventListener('keydown', event => {
          if (video.controls && [' ', 'Enter', 'k', 'K', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) this.takeManualControl(video);
        }, options);
        video.addEventListener('play', () => {
          if (document.hidden || (this.observer && !this.videoVisible(video))) {
            video.pause();
            return;
          }
          if (this.automatic.has(video) && !this.manual.has(video)) {
            if (!this.allowed.has(video) || !this.automaticAllowed() || this.userPausedAutoplay) video.pause();
          } else {
            this.takeManualControl(video);
          }
        }, options);
        video.addEventListener('ended', () => {
          // Loop-off really stops; don't restart the same clip during observer updates.
          if (!video.loop) {
            this.failed.add(video);
            this.syncPlayback();
          }
        }, options);
        video.addEventListener('error', () => {
          this.failed.add(video);
          this.restoreNativePlayer(video);
          this.syncPlayback();
        }, options);
        this.setupPlayer(video, options);
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => this.ratios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0));
          this.syncPlayback();
        }, { threshold: [0, .01, .25, .5, .6, .65, .7, .75, .8, .85, .9, .95, 1] });
        this.videos.forEach(video => this.observer.observe(video));
        this.entranceObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this.entranceObserver.unobserve(entry.target);
            if (!this.animationAllowed() || !entry.target.animate) return;
            const frames = entry.target.classList.contains('kv-backdrop')
              ? [{ opacity: 0 }, { opacity: 1 }]
              : [{ opacity: .65, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }];
            const animation = entry.target.animate(frames, { duration: 400, easing: 'ease-out' });
            this.animations.add(animation);
            animation.finished.then(() => this.animations.delete(animation), () => this.animations.delete(animation));
          });
        }, { threshold: .05 });
        this.querySelectorAll('.kv-surface, .kv-backdrop').forEach(node => this.entranceObserver.observe(node));
      }
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => { this.measure(); this.scheduleNavigation(); });
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', () => { this.measure(); this.scheduleNavigation(); }, options);
      }
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest?.('.kv-card');
        if (card && this.contains(card)) card.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
      }, options);
      this.setAttribute('data-ready', '');
      this.measure();
      this.updateNavigation();
      this.updateAutoplayButton();
    }
    animationAllowed() {
      return this.dataset.animations === 'true' && !this.motion.matches &&
        (!this.mobile.matches || this.dataset.mobileAnimations === 'true');
    }
    automaticAllowed() {
      return this.dataset.autoplay === 'true' && this.dataset.editor !== 'true' &&
        !!this.observer && !this.motion.matches && !this.connection?.saveData;
    }
    updateAutoplayButton() {
      if (!this.autoplayButton) return;
      const hidden = !this.automaticAllowed() || this.videos.length === 0;
      if (this.autoplayButton.hidden !== hidden) this.autoplayButton.hidden = hidden;
      this.toggleAttribute('data-autoplay-paused', this.userPausedAutoplay);
      const label = this.userPausedAutoplay ? 'Resume autoplay' : 'Pause autoplay';
      if (this.autoplayText && this.autoplayText.textContent !== label) this.autoplayText.textContent = label;
    }
    takeManualControl(video) {
      const index = this.videoIndexes.get(video) ?? -1;
      this.preferredIndex = index;
      this.setCurrentCard(index);
      this.manual.add(video);
      this.automatic.delete(video);
      this.userVideo = video;
      this.userPausedAutoplay = true;
      this.allowed.clear();
      this.videos.forEach(other => { if (other !== video && !other.paused) other.pause(); });
      this.updateAutoplayButton();
    }
    videoVisible(video) {
      return (this.ratios.get(video) || 0) > 0 || !!document.fullscreenElement?.contains(video) || !!video.webkitDisplayingFullscreen;
    }
    pauseAll() {
      this.videos.forEach(video => { if (!video.paused) video.pause(); });
    }
    syncPlayback() {
      if (!this.initialized) return;
      const previous = this.allowed;
      this.allowed = new Set();
      this.updateAutoplayButton();
      if (document.hidden) { this.pauseAll(); return; }
      // Native playback remains available when automatic playback is disabled.
      if (this.userPausedAutoplay || !this.automaticAllowed()) {
        this.videos.forEach(video => {
          if (!video.paused && (!this.manual.has(video) || (this.observer && !this.videoVisible(video)))) video.pause();
        });
        return;
      }
      const candidates = this.videos.filter(video => (this.ratios.get(video) || 0) >= .65 && !this.failed.has(video) && !this.manual.has(video));
      // Retain a current video on ties to prevent constant switching at rest.
      const selectedVideo = this.cardVideos[this.currentIndex];
      candidates.sort((a, b) => {
        if (a === selectedVideo) return -1;
        if (b === selectedVideo) return 1;
        const difference = (this.ratios.get(b) || 0) - (this.ratios.get(a) || 0);
        if (Math.abs(difference) > .025) return difference;
        return Number(previous.has(b)) - Number(previous.has(a));
      });
      const limit = this.mobile.matches ? 1 : Math.min(2, Math.max(1, Number(this.dataset.limit) || 1));
      this.allowed = new Set(candidates.slice(0, limit));
      this.videos.forEach(video => {
        if (!this.allowed.has(video)) { if (!video.paused) video.pause(); }
        else if (video.paused && !this.pending.has(video)) this.playAutomatic(video);
      });
    }
    playAutomatic(video, retryOnAbort = true) {
      const generation = this.generation;
      const pending = this.pending;
      let playbackError = null;
      pending.add(video);
      this.automatic.add(video);
      video.muted = true;
      Promise.resolve().then(() => {
        if (!this.initialized || this.generation !== generation || !this.allowed.has(video) || this.userPausedAutoplay || document.hidden) return;
        return video.play();
      }).then(() => {
        if (this.generation !== generation) return;
        if (!this.initialized || document.hidden || (!this.manual.has(video) && !this.allowed.has(video))) video.pause();
      }).catch(error => {
        if (!this.initialized || this.generation !== generation || this.manual.has(video)) return;
        playbackError = error;
        // A real failure excludes only this clip; manual playback stays available.
        if (error.name !== 'AbortError') this.failed.add(video);
      }).finally(() => {
        pending.delete(video);
        if (!playbackError || !this.initialized || this.generation !== generation) return;
        if (playbackError.name !== 'AbortError') {
          this.syncPlayback();
        } else if (retryOnAbort && video.paused && this.allowed.has(video) &&
          !this.manual.has(video) && !this.userPausedAutoplay && !document.hidden && this.automaticAllowed()) {
          // A rapid scroll can cancel play and make the same clip eligible again.
          // Retry once, without creating an unbounded loop on browser rejection.
          this.playAutomatic(video, false);
        }
      });
    }
    measure() {
      const style = getComputedStyle(this.track);
      this.geometry = {
        rtl: style.direction === 'rtl',
        left: parseFloat(style.paddingLeft) || 0,
        right: parseFloat(style.paddingRight) || 0,
        step: (this.cards[0]?.offsetWidth || 0) + (parseFloat(style.columnGap) || 0)
      };
    }
    scheduleNavigation() {
      if (this.navigationFrame) return;
      this.navigationFrame = requestAnimationFrame(() => { this.navigationFrame = null; this.updateNavigation(); });
    }
    updateNavigation() {
      if (!this.cards.length || !this.geometry) return;
      const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
      if (this.navigation && this.navigation.hidden !== !overflow) this.navigation.hidden = !overflow;
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const offset = Math.min(maxScroll, Math.abs(this.track.scrollLeft));
      const atStart = !overflow || offset < 2;
      const atEnd = !overflow || offset >= maxScroll - 2;
      if (this.previous && this.previous.disabled !== atStart) this.previous.disabled = atStart;
      if (this.next && this.next.disabled !== atEnd) this.next.disabled = atEnd;
      let index = Math.min(this.cards.length - 1, Math.round(offset / Math.max(1, this.geometry.step)));
      if (this.preferredIndex >= 0) {
        const card = this.cards[this.preferredIndex]?.getBoundingClientRect();
        const track = this.track.getBoundingClientRect();
        if (card && Math.min(card.right, track.right) - Math.max(card.left, track.left) >= card.width * .7) index = this.preferredIndex;
      }
      const changed = index !== this.currentIndex;
      this.setCurrentCard(index);
      if (changed) this.syncPlayback();
      if (this.dotsContainer?.hidden) this.dotsContainer.hidden = false;
    }
    setCurrentCard(index) {
      if (index < 0 || index >= this.cards.length || index === this.currentIndex) return;
      this.currentIndex = index;
      this.cards.forEach((card, i) => card.classList.toggle('is-current', i === index));
      this.dots.forEach((button, i) => {
        if (i === index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      if (this.counter) this.counter.textContent = String(index + 1);
    }
    goToCard(index) {
      if (!this.cards[index] || !this.geometry) return;
      this.preferredIndex = index;
      this.setCurrentCard(index);
      const card = this.cards[index].getBoundingClientRect();
      const track = this.track.getBoundingClientRect();
      const delta = this.geometry.rtl ? card.right - (track.right - this.geometry.right) : card.left - (track.left + this.geometry.left);
      this.track.scrollBy({ left: delta, behavior: this.scrollBehavior() });
      this.syncPlayback();
    }
    setupPlayer(video, options) {
      const media = video.closest('.kv-media');
      const controls = media?.querySelector('.kv-player');
      if (!controls) return;
      const player = {
        media, controls, seeking: false,
        play: controls.querySelector('[data-control="play"]'),
        mute: controls.querySelector('[data-control="mute"]'),
        fullscreen: controls.querySelector('[data-control="fullscreen"]'),
        seek: controls.querySelector('[data-seek]'),
        time: controls.querySelector('[data-time]'),
        error: media.querySelector('.kv-media-error')
      };
      this.players.set(video, player);
      player.play.addEventListener('click', () => this.toggleVideo(video), options);
      player.mute.addEventListener('click', () => {
        this.takeManualControl(video);
        const silent = video.muted || video.volume === 0;
        if (silent && video.volume === 0) video.volume = 1;
        video.muted = !silent;
      }, options);
      player.fullscreen.hidden = !((document.fullscreenEnabled && media.requestFullscreen) || video.webkitEnterFullscreen);
      player.fullscreen.addEventListener('click', async () => {
        const generation = this.generation;
        this.takeManualControl(video);
        try {
          if (document.fullscreenElement === media) await document.exitFullscreen();
          else if (document.fullscreenEnabled && media.requestFullscreen) await media.requestFullscreen();
          else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
        } catch (_) {
          if (this.initialized && this.generation === generation) this.showPlayerMessage(video, 'Fullscreen is unavailable in this browser.');
        }
      }, options);
      video.addEventListener('click', () => { if (media.classList.contains('is-enhanced')) this.toggleVideo(video); }, options);
      player.seek.addEventListener('pointerdown', () => { player.seeking = true; }, options);
      player.seek.addEventListener('input', () => {
        const duration = video.duration;
        const ranges = video.seekable;
        if (!Number.isFinite(duration) || duration <= 0 || !ranges.length) return;
        const requested = Math.max(0, Math.min(duration, Number(player.seek.value) / 1000 * duration));
        let target = null;
        let distance = Infinity;
        // Seekable media may start after zero or contain gaps between ranges.
        for (let i = 0; i < ranges.length; i++) {
          const start = Math.max(0, ranges.start(i));
          const end = Math.min(duration, ranges.end(i));
          if (end <= start) continue;
          const candidate = Math.max(start, Math.min(requested, Math.max(start, end - .05)));
          if (Math.abs(candidate - requested) < distance) {
            target = candidate;
            distance = Math.abs(candidate - requested);
          }
        }
        if (target === null) return;
        this.takeManualControl(video);
        try {
          video.currentTime = target;
        } catch (_) {
          this.showPlayerMessage(video, 'Seeking is unavailable. Please try again when the video has loaded.');
        }
        this.updatePlayer(video);
      }, options);
      ['play', 'pause', 'loadedmetadata', 'durationchange', 'timeupdate', 'volumechange', 'ended', 'progress', 'loadeddata'].forEach(name => video.addEventListener(name, () => this.schedulePlayerUpdate(video), options));
      video.addEventListener('play', () => {
        if (player.error && !player.error.hidden) player.error.hidden = true;
      }, options);
      // Keep the native player until custom controls and handlers are attached.
      controls.hidden = false;
      media.classList.add('is-enhanced');
      video.controls = false;
      this.updatePlayer(video);
    }
    schedulePlayerUpdate(video) {
      if (!this.initialized) return;
      this.playerUpdates.add(video);
      if (this.playerFrame) return;
      this.playerFrame = requestAnimationFrame(() => {
        this.playerFrame = null;
        this.playerUpdates.forEach(item => this.updatePlayer(item));
        this.playerUpdates.clear();
      });
    }
    updatePlayer(video) {
      const player = this.players.get(video);
      if (!player) return;
      const playing = !video.paused && !video.ended;
      const audible = !video.muted && video.volume > 0;
      if (player.playing !== playing) {
        player.playing = playing;
        player.media.classList.toggle('is-playing', playing);
        player.play.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }
      if (player.audible !== audible) {
        player.audible = audible;
        player.media.classList.toggle('is-unmuted', audible);
        player.mute.setAttribute('aria-label', audible ? 'Mute video' : 'Unmute video');
      }
      const duration = Number.isFinite(video.duration) ? Math.max(0, video.duration) : 0;
      const time = Number.isFinite(video.currentTime) ? Math.max(0, video.currentTime) : 0;
      const clock = value => Math.floor(value / 60) + ':' + String(Math.floor(value % 60)).padStart(2, '0');
      const ranges = video.seekable;
      const disabled = duration <= 0 || !ranges.length || ranges.end(ranges.length - 1) <= ranges.start(0);
      if (player.seek.disabled !== disabled) player.seek.disabled = disabled;
      const progress = String(duration > 0 ? Math.min(1000, Math.round(time / duration * 1000)) : 0);
      if (!player.seeking && player.seek.value !== progress) player.seek.value = progress;
      const spokenTime = clock(time) + (duration ? ' of ' + clock(duration) : '');
      const displayTime = clock(time) + (duration ? ' / ' + clock(duration) : '');
      if (player.seek.getAttribute('aria-valuetext') !== spokenTime) player.seek.setAttribute('aria-valuetext', spokenTime);
      if (player.time.textContent !== displayTime) player.time.textContent = displayTime;
      // Playback clears prior messages on its play event, not on each time update.
    }
    toggleVideo(video) {
      this.takeManualControl(video);
      const generation = this.generation;
      const request = {};
      this.manualRequests.set(video, request);
      if (!video.paused) { video.pause(); return; }
      const onFailure = error => {
        // Pausing or switching clips can interrupt play without a media failure.
        if (error.name === 'AbortError' || !this.initialized || this.generation !== generation ||
          this.manualRequests.get(video) !== request || this.userVideo !== video || !this.manual.has(video)) return;
        this.restoreNativePlayer(video);
      };
      try {
        // Keep play() directly inside the gesture to preserve sound permissions.
        Promise.resolve(video.play()).catch(onFailure);
      } catch (error) {
        onFailure(error);
      }
    }
    showPlayerMessage(video, message) {
      const element = this.players.get(video)?.error;
      if (!element) return;
      element.textContent = message;
      element.hidden = false;
    }
    restoreNativePlayer(video) {
      const player = this.players.get(video);
      if (!player) return;
      const restoreFocus = player.controls.contains(document.activeElement);
      player.media.classList.remove('is-enhanced');
      player.controls.hidden = true;
      video.controls = true;
      this.showPlayerMessage(video, 'This video could not play. Please try the video player again.');
      // Do not leave keyboard focus inside controls that have just been hidden.
      if (restoreFocus && video.isConnected) video.focus({ preventScroll: true });
    }
    scrollBehavior() { return this.motion.matches ? 'auto' : 'smooth'; }
    scrollByCard(direction) {
      if (!this.geometry) return;
      this.preferredIndex = -1;
      this.track.scrollBy({ left: direction * this.geometry.step * (this.geometry.rtl ? -1 : 1), behavior: this.scrollBehavior() });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.navigationFrame);
      cancelAnimationFrame(this.playerFrame);
      this.initialized = false;
      this.generation = (this.generation || 0) + 1;
      this.events?.abort();
      this.observer?.disconnect();
      this.entranceObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      this.allowed?.clear();
      if (this.videos) this.pauseAll();
      this.navigationFrame = null;
      this.playerFrame = null;
      this.playerUpdates?.clear();
      this.players?.forEach((player, video) => { video.controls = true; player.controls.hidden = true; player.media.classList.remove('is-enhanced'); });
      this.removeAttribute('data-ready');
    }
  }
  customElements.define('karyliz-video-carousel', KarylizVideoCarousel);
})();

  } catch(e) { console.error(e); }
})();
})();
